import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Badge } from './ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import axios from 'axios';
import { toast } from 'sonner';
import { QRCodeSVG } from 'qrcode.react';
import DuplicarClaseModal from './DuplicarClaseModal';
import EliminarClaseModal from './EliminarClaseModal';
import PruebasExamenes from './PruebasExamenes';

const Clases = () => {
  const { user, API, getImageUrl } = useContext(AuthContext);
  
  // Helper para verificar si es estudiante, pastor o graduado (mismo comportamiento)
  const isStudentRole = (rol) => ['estudiante', 'pastor', 'graduado'].includes(rol);
  
  const [clases, setClases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profesores, setProfesores] = useState([]);
  const [semestresActivos, setSemestresActivos] = useState([]);
  const [semestresInfo, setSemestresInfo] = useState({}); // To store semester names
  const [newClase, setNewClase] = useState({
    titulo: '',
    descripcion: '',
    categoria: 'estudiantes',
    semestres: [],
    profesor_id: 'auto',
    zoom_link: '',
    playlist_youtube: '',
    imagen_url: '',
    banner_url: '',
    dias_semana: [],
    fecha_inicio: '',
    fecha_fin: '',
    zoom_meeting_id: null,
    zoom_join_url: '',
    zoom_start_url: '',
    zoom_topic: '',
    es_ministerial: false,
    es_abierta: false,
    es_extracurricular: false,
    modalidad: 'vivo'
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [editingClase, setEditingClase] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [editForm, setEditForm] = useState({});

  // Auto-Capacitación: clase de pruebas obligatorias para profesores no calificados
  const [autoCapClase, setAutoCapClase] = useState(null);
  
  // Estados para inscribir profesores
  const [isInscribirProfesoresOpen, setIsInscribirProfesoresOpen] = useState(false);
  const [claseParaInscribir, setClaseParaInscribir] = useState(null);
  const [profesoresDisponibles, setProfesoresDisponibles] = useState([]);
  const [profesoresSeleccionados, setProfesoresSeleccionados] = useState([]);
  const [inscribiendo, setInscribiendo] = useState(false);
  const [mensajeOpcional, setMensajeOpcional] = useState('');

  // Estados para inscribir estudiantes manualmente
  const [isInscribirEstudiantesOpen, setIsInscribirEstudiantesOpen] = useState(false);
  const [claseParaInscribirEstudiantes, setClaseParaInscribirEstudiantes] = useState(null);
  const [estudiantesDisponibles, setEstudiantesDisponibles] = useState([]);
  const [estudiantesSeleccionados, setEstudiantesSeleccionados] = useState([]);
  const [inscribiendoEstudiantes, setInscribiendoEstudiantes] = useState(false);
  const [busquedaEstudiante, setBusquedaEstudiante] = useState('');
  
  // Estados para inscribir usuarios en devocionales
  const [isInscribirDevocionalOpen, setIsInscribirDevocionalOpen] = useState(false);
  const [claseParaInscribirDevocional, setClaseParaInscribirDevocional] = useState(null);
  const [usuariosDisponiblesDevocional, setUsuariosDisponiblesDevocional] = useState([]);
  const [usuariosSeleccionadosDevocional, setUsuariosSeleccionadosDevocional] = useState([]);
  const [inscribiendoDevocional, setInscribiendoDevocional] = useState(false);
  const [busquedaDevocional, setBusquedaDevocional] = useState('');
  const [rolFiltroDevocional, setRolFiltroDevocional] = useState('todos');

  // Estados para asistencias
  const [asistencias, setAsistencias] = useState([]);
  const [showAsistencias, setShowAsistencias] = useState(false);
  const [selectedClaseAsistencias, setSelectedClaseAsistencias] = useState(null);
  const [loadingAsistencias, setLoadingAsistencias] = useState(false);
  const [marcandoAsistencia, setMarcandoAsistencia] = useState({});
  
  // Estados para modal de asistencia
  const [showAsistenciaModal, setShowAsistenciaModal] = useState(false);
  const [claseAsistenciaSeleccionada, setClaseAsistenciaSeleccionada] = useState(null);
  
  // Estado para mostrar recuadro de acceso a Zoom después de marcar presente
  const [showZoomAccess, setShowZoomAccess] = useState(false);
  const [claseZoomAcceso, setClaseZoomAcceso] = useState(null);
  
  // Estado para verificación de cámara
  const [showCameraCheck, setShowCameraCheck] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [cameraError, setCameraError] = useState(null);
  const videoRef = React.useRef(null);
  
  // Estado para modal de QR de asistencia presencial
  const [showQRModal, setShowQRModal] = useState(false);
  const [selectedClaseQR, setSelectedClaseQR] = useState(null);
  
  // Estados para modales de Duplicar y Eliminar clase
  const [isDuplicarModalOpen, setIsDuplicarModalOpen] = useState(false);
  const [isEliminarModalOpen, setIsEliminarModalOpen] = useState(false);
  const [selectedClaseForAction, setSelectedClaseForAction] = useState(null);
  
  // Estado para modal de estudiantes inscritos
  const [showEstudiantesModal, setShowEstudiantesModal] = useState(false);
  const [estudiantesInscritos, setEstudiantesInscritos] = useState([]);
  const [loadingEstudiantes, setLoadingEstudiantes] = useState(false);
  const [selectedClaseEstudiantes, setSelectedClaseEstudiantes] = useState(null);
  const [validacionEliminacion, setValidacionEliminacion] = useState(null);
  
  // Estado para reuniones de Zoom
  const [zoomMeetings, setZoomMeetings] = useState([]);
  const [loadingZoomMeetings, setLoadingZoomMeetings] = useState(false);
  const [creandoZoomMeeting, setCreandoZoomMeeting] = useState({});
  
  // Estados para filtros
  const [filtroActiva, setFiltroActiva] = useState('activas'); // Por defecto mostrar solo activas
  const [filtroSemestre, setFiltroSemestre] = useState('todos'); // 'todos' o ID de semestre
  const [filtroAño, setFiltroAño] = useState('todos'); // 'todos' o año específico
  const [filtroRegistro, setFiltroRegistro] = useState('todos'); // 'todos', 'registrado', 'sin_registrar'
  
  // Estados para control de matrícula de estudiantes
  const [estadoMatricula, setEstadoMatricula] = useState(null);
  const [semestresPagados, setSemestresPagados] = useState([]);

  useEffect(() => {
    loadClases();
    if (isStudentRole(user?.rol)) {
      loadEstadoMatricula();
    }
    loadSemestresActivos();
    if (user.rol === 'admin') {
      loadProfesores();
    }
    // Profesor no calificado: cargar (y auto-inscribir) la clase de Auto-Capacitación obligatoria
    if (user?.rol === 'profesor' && user?.capacitado === false) {
      (async () => {
        try {
          const r = await axios.get(`${API}/profesor/auto-capacitacion`);
          setAutoCapClase(r.data);
        } catch (e) {
          console.error('Error cargando auto-capacitación:', e);
        }
      })();
    }
  }, []);

  useEffect(() => {
    // Cargar reuniones de Zoom cuando se abre el diálogo de crear clase
    if (isDialogOpen && user.rol === 'admin') {
      loadZoomMeetings();
    }
  }, [isDialogOpen]);

  const loadClases = async () => {
    try {
      // Agregar timestamp para evitar cache del navegador
      const response = await axios.get(`${API}/clases?_t=${Date.now()}`);
      
      // Limpiar estado anterior y establecer nuevos datos
      setClases([]);
      
      // Pequeño delay para forzar re-render
      await new Promise(resolve => setTimeout(resolve, 50));
      
      // Clases cargadas exitosamente
      setClases(response.data);
    } catch (error) {
      console.error('Error loading clases:', error);
      toast.error(formatBackendError(error) || 'Error al cargar clases');
    } finally {
      setLoading(false);
    }
  };

  const loadZoomMeetings = async () => {
    try {
      setLoadingZoomMeetings(true);
      const response = await axios.get(`${API}/admin/zoom/meetings`);
      setZoomMeetings(response.data.meetings || []);
      console.log('✅ Reuniones de Zoom cargadas:', response.data.meetings?.length || 0);
    } catch (error) {
      console.error('Error cargando reuniones de Zoom:', error);
      // No mostrar error toast, solo fallar silenciosamente
    } finally {
      setLoadingZoomMeetings(false);
    }
  };

  const crearZoomMeeting = async (clase) => {
    try {
      setCreandoZoomMeeting({ ...creandoZoomMeeting, [clase.id]: true });
      
      const response = await axios.post(`${API}/admin/clases/${clase.id}/crear-zoom-meeting`);
      
      if (response.data.success) {
        const { meetings_created, total_expected } = response.data;
        toast.success(`🎉 Se crearon ${meetings_created} de ${total_expected} reuniones de Zoom`);
        // Recargar clases para ver el cambio
        await loadClases();
      }
    } catch (error) {
      console.error('Error creando reunión de Zoom:', error);
      const errorMsg = error.response?.data?.detail || 'Error al crear reunión de Zoom';
      toast.error(errorMsg);
    } finally {
      setCreandoZoomMeeting({ ...creandoZoomMeeting, [clase.id]: false });
    }
  };
  
  const eliminarZoomMeetings = async (clase) => {
    if (!window.confirm(`¿Eliminar todas las reuniones de Zoom de "${clase.titulo}"?`)) {
      return;
    }
    
    try {
      const response = await axios.delete(`${API}/admin/clases/${clase.id}/zoom-meetings`);
      
      if (response.data.success) {
        toast.success(`✅ Se eliminaron ${response.data.deleted_count} reuniones de Zoom`);
        await loadClases();
      }
    } catch (error) {
      console.error('Error eliminando reuniones de Zoom:', error);
      toast.error(error.response?.data?.detail || 'Error al eliminar reuniones');
    }
  };

  const limpiarDatosZoom = async (clase) => {
    if (!window.confirm(`¿Limpiar datos de Zoom de "${clase.titulo}"?\n\nEsto solo limpia los datos en IBA Connect (NO borra en Zoom).\nÚsalo si ya borraste las reuniones directamente en Zoom.`)) {
      return;
    }
    
    try {
      const response = await axios.post(`${API}/admin/clases/${clase.id}/clear-zoom-data`);
      
      if (response.data.success) {
        toast.success(`✅ ${response.data.message}`);
        await loadClases();
      }
    } catch (error) {
      console.error('Error limpiando datos de Zoom:', error);
      toast.error(error.response?.data?.detail || 'Error al limpiar datos');
    }
  };

  const loadProfesores = async () => {
    try {
      const response = await axios.get(`${API}/profesores`);
      setProfesores(response.data);
    } catch (error) {
      console.error('Error al cargar profesores:', error);
    }
  };

  const loadEstadoMatricula = async () => {
    try {
      const response = await axios.get(`${API}/estudiantes/estado-matricula`);
      setEstadoMatricula(response.data);
      setSemestresPagados(response.data.semestres_pagados || []);
    } catch (error) {
      console.error('Error al cargar estado de matrícula:', error);
    }
  };


  const loadSemestresActivos = async () => {
    try {
      // Admin can see ALL semesters, others only active
      const endpoint = user?.rol === 'admin' ? `${API}/semestres` : `${API}/semestres-activos`;
      const response = await axios.get(endpoint);
      
      if (response.data && response.data.length > 0) {
        // Extract semester numbers and build info object
        const semestreNumeros = response.data.map(s => s.semester_number || s.numero);
        const semestreInfoObj = {};
        response.data.forEach(s => {
          const num = s.semester_number || s.numero;
          const nombre = s.name || s.nombre;
          semestreInfoObj[num] = nombre;
        });
        
        setSemestresActivos(semestreNumeros);
        setSemestresInfo(semestreInfoObj);
      }
    } catch (error) {
      console.error('Error al cargar semestres:', error);
      // Keep default [1,2,3,4] on error
    }
  };

  // Helper function to get semester name
  const getSemestreNombre = (numero) => {
    return semestresInfo[numero] || `${numero}° Semestre`;
  };


  // Función para abrir modal de inscribir profesores
  const abrirModalInscribirProfesores = async (clase) => {
    setClaseParaInscribir(clase);
    setProfesoresSeleccionados([]);
    setMensajeOpcional('');
    
    // Cargar lista de profesores disponibles
    try {
      const response = await axios.get(`${API}/users`);
      const todosProfesores = response.data.filter(u => u.rol === 'profesor');
      
      // Marcar cuáles ya están inscritos
      const profesoresConEstado = todosProfesores.map(prof => ({
        ...prof,
        yaInscrito: clase.estudiantes_inscritos?.includes(prof.id) || false
      }));
      
      setProfesoresDisponibles(profesoresConEstado);
      setIsInscribirProfesoresOpen(true);
    } catch (error) {
      console.error('Error cargando profesores:', error);
      toast.error('Error al cargar lista de profesores');
    }
  };

  // Función para manejar selección de profesores
  const toggleProfesorSeleccion = (profesorId) => {
    setProfesoresSeleccionados(prev => {
      if (prev.includes(profesorId)) {
        return prev.filter(id => id !== profesorId);
      } else {
        return [...prev, profesorId];
      }
    });
  };

  // Función para seleccionar/deseleccionar todos
  const toggleSeleccionarTodos = () => {
    const profesoresNoInscritos = profesoresDisponibles.filter(p => !p.yaInscrito);
    if (profesoresSeleccionados.length === profesoresNoInscritos.length) {
      setProfesoresSeleccionados([]);
    } else {
      setProfesoresSeleccionados(profesoresNoInscritos.map(p => p.id));
    }
  };

  // Función para inscribir profesores seleccionados
  const handleInscribirProfesores = async () => {
    if (profesoresSeleccionados.length === 0) {
      toast.error('Selecciona al menos un profesor');
      return;
    }

    const confirmacion = window.confirm(
      `¿Inscribir a ${profesoresSeleccionados.length} profesor(es) en la capacitación "${claseParaInscribir.nombre}"?`
    );
    
    if (!confirmacion) return;

    setInscribiendo(true);
    try {
      const response = await axios.post(
        `${API}/admin/clases/${claseParaInscribir.id}/inscribir-profesores`,
        {
          profesor_ids: profesoresSeleccionados,
          mensaje_opcional: mensajeOpcional || null
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
        
        // Mostrar detalles
        if (response.data.inscritos_exitosos.length > 0) {
          console.log('Profesores inscritos:', response.data.inscritos_exitosos);
        }
        if (response.data.ya_inscritos.length > 0) {
          toast.info(`${response.data.ya_inscritos.length} ya estaba(n) inscrito(s)`);
        }
        if (response.data.errores.length > 0) {
          toast.error(`${response.data.errores.length} error(es) al inscribir`);
        }

        // Cerrar modal y recargar clases
        setIsInscribirProfesoresOpen(false);
        loadClases();
      }
    } catch (error) {
      console.error('Error inscribiendo profesores:', error);
      toast.error(error.response?.data?.detail || 'Error al inscribir profesores');
    } finally {
      setInscribiendo(false);
    }
  };

  // Funciones para inscribir estudiantes manualmente
  const abrirModalInscribirEstudiantes = async (clase) => {
    setClaseParaInscribirEstudiantes(clase);
    setEstudiantesSeleccionados([]);
    setBusquedaEstudiante('');
    
    try {
      // Cargar todos los estudiantes usando el endpoint correcto
      const response = await axios.get(`${API}/users/estudiantes`);
      const estudiantes = (response.data || []).map(est => ({
        id: est.id,
        nombre: est.nombre_completo || est.nombre || '',
        apellido: est.apellido || '',
        email: est.email,
        yaInscrito: clase.estudiantes_inscritos?.includes(est.id) || false
      }));
      setEstudiantesDisponibles(estudiantes);
      setIsInscribirEstudiantesOpen(true);
    } catch (error) {
      console.error('Error cargando estudiantes:', error);
      toast.error('Error al cargar estudiantes');
    }
  };

  const handleInscribirEstudiantes = async () => {
    if (!claseParaInscribirEstudiantes || estudiantesSeleccionados.length === 0) {
      toast.error('Selecciona al menos un estudiante');
      return;
    }

    setInscribiendoEstudiantes(true);
    try {
      const response = await axios.post(
        `${API}/admin/clases/${claseParaInscribirEstudiantes.id}/inscribir-estudiantes`,
        { estudiante_ids: estudiantesSeleccionados }
      );

      if (response.data.success) {
        toast.success(`${response.data.inscritos} estudiante(s) inscrito(s) exitosamente`);
        setIsInscribirEstudiantesOpen(false);
        loadClases();
      }
    } catch (error) {
      console.error('Error inscribiendo estudiantes:', error);
      toast.error(error.response?.data?.detail || 'Error al inscribir estudiantes');
    } finally {
      setInscribiendoEstudiantes(false);
    }
  };

  const estudiantesFiltrados = estudiantesDisponibles.filter(est => {
    if (!busquedaEstudiante) return true;
    const busqueda = busquedaEstudiante.toLowerCase();
    const nombreCompleto = `${est.nombre || ''} ${est.apellido || ''}`.toLowerCase();
    return (
      nombreCompleto.includes(busqueda) ||
      est.email?.toLowerCase().includes(busqueda)
    );
  });

  // Funciones para inscribir usuarios en devocionales
  const abrirModalInscribirDevocional = async (clase) => {
    setClaseParaInscribirDevocional(clase);
    setUsuariosSeleccionadosDevocional([]);
    setBusquedaDevocional('');
    setRolFiltroDevocional('todos');
    
    try {
      const response = await axios.get(`${API}/users`);
      const usuarios = (response.data || [])
        .filter(u => u.activo === true && ['estudiante', 'profesor', 'pastor', 'graduado', 'admin'].includes(u.rol))
        .map(u => ({
          id: u.id,
          nombre: u.nombre || '',
          apellido: u.apellido || '',
          email: u.email,
          rol: u.rol,
          yaInscrito: clase.estudiantes_inscritos?.includes(u.id) || false
        }));
      setUsuariosDisponiblesDevocional(usuarios);
      setIsInscribirDevocionalOpen(true);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
      toast.error('Error al cargar usuarios');
    }
  };

  const handleInscribirDevocional = async () => {
    if (!claseParaInscribirDevocional || usuariosSeleccionadosDevocional.length === 0) {
      toast.error('Selecciona al menos un usuario');
      return;
    }

    setInscribiendoDevocional(true);
    try {
      const response = await axios.post(
        `${API}/admin/clases/${claseParaInscribirDevocional.id}/inscribir-estudiantes`,
        { estudiante_ids: usuariosSeleccionadosDevocional }
      );

      if (response.data.success) {
        toast.success(`${response.data.inscritos} usuario(s) inscrito(s) exitosamente`);
        setIsInscribirDevocionalOpen(false);
        loadClases();
      }
    } catch (error) {
      console.error('Error inscribiendo usuarios:', error);
      toast.error(error.response?.data?.detail || 'Error al inscribir usuarios');
    } finally {
      setInscribiendoDevocional(false);
    }
  };

  const usuariosFiltradosDevocional = usuariosDisponiblesDevocional.filter(u => {
    if (rolFiltroDevocional !== 'todos' && u.rol !== rolFiltroDevocional) return false;
    if (!busquedaDevocional) return true;
    const busqueda = busquedaDevocional.toLowerCase();
    const nombreCompleto = `${u.nombre || ''} ${u.apellido || ''}`.toLowerCase();
    return nombreCompleto.includes(busqueda) || u.email?.toLowerCase().includes(busqueda);
  });

  const handleCreateClase = async (e) => {
    e.preventDefault();
    if (!newClase.titulo || !newClase.descripcion || !newClase.fecha_inicio || !newClase.fecha_fin) {
      toast.error('Por favor completa todos los campos obligatorios');
      return;
    }

    setCreating(true);
    try {
      // Convertir las fechas ingresadas a formato con timezone de Montevideo
      // El usuario ingresa hora de Montevideo, debemos enviarla como tal
      const fechaInicioMontevideo = `${newClase.fecha_inicio}:00-03:00`; // Agregar timezone -03:00
      const fechaFinMontevideo = `${newClase.fecha_fin}:00-03:00`;
      
      const response = await axios.post(`${API}/clases`, {
        ...newClase,
        fecha_inicio: fechaInicioMontevideo,
        fecha_fin: fechaFinMontevideo
      });
      
      setClases([response.data, ...clases]);
      setNewClase({
        titulo: '',
        descripcion: '',
        categoria: 'estudiantes',
        semestres: [],
        profesor_id: 'auto',
        zoom_link: '',
        playlist_youtube: '',
        imagen_url: '',
        banner_url: '',
        dias_semana: [],
        fecha_inicio: '',
        fecha_fin: '',
        zoom_meeting_id: null,
        zoom_join_url: '',
        zoom_start_url: '',
        zoom_topic: '',
        es_ministerial: false,
        es_abierta: false,
        es_extracurricular: false,
        modalidad: 'vivo'
      });
      setIsDialogOpen(false);
      toast.success('Clase creada exitosamente');
    } catch (error) {
      console.error('Error creating clase:', error);
      toast.error(formatBackendError(error) || 'Error al crear clase');
    } finally {
      setCreating(false);
    }
  };

  const openEditDialog = (clase) => {
    setEditingClase(clase);
    setEditForm({
      titulo: clase.titulo,
      descripcion: clase.descripcion,
      categoria: clase.categoria,
      semestres: clase.semestres || [],
      profesor_id: clase.profesor_id || 'auto', // Use 'auto' as default for consistency
      zoom_link: clase.zoom_link || '',
      playlist_youtube: clase.playlist_youtube || '',
      imagen_url: clase.imagen_url || '',
      banner_url: clase.banner_url || '',
      dias_semana: clase.dias_semana || [],
      fecha_inicio: clase.fecha_inicio ? convertUTCToMontevideo(clase.fecha_inicio) : '',
      fecha_fin: clase.fecha_fin ? convertUTCToMontevideo(clase.fecha_fin) : '',
      es_ministerial: clase.es_ministerial || false,
      es_abierta: clase.es_abierta || false,
      es_extracurricular: clase.es_extracurricular || false,
      modalidad: clase.modalidad || 'vivo'
    });
    setIsEditDialogOpen(true);
  };

  const handleEditClase = async (e) => {
    e.preventDefault();
    setUpdating(true);
    
    try {
      // Convertir las fechas ingresadas a formato con timezone de Montevideo
      const fechaInicioMontevideo = editForm.fecha_inicio ? `${editForm.fecha_inicio}:00-03:00` : null;
      const fechaFinMontevideo = editForm.fecha_fin ? `${editForm.fecha_fin}:00-03:00` : null;
      
      const claseData = {
        ...editForm,
        fecha_inicio: fechaInicioMontevideo,
        fecha_fin: fechaFinMontevideo
      };

      await axios.put(`${API}/clases/${editingClase.id}`, claseData);
      
      // Cerrar modal y limpiar estado
      setIsEditDialogOpen(false);
      setEditingClase(null);
      
      // Forzar recarga INMEDIATA de clases
      setLoading(true);
      await loadClases();
      
      toast.success('Clase actualizada exitosamente');
    } catch (error) {
      console.error('Error updating clase:', error);
      toast.error(formatBackendError(error) || 'Error al actualizar clase');
    } finally {
      setUpdating(false);
    }
  };

  const handleDeleteClase = async (clase) => {
    // Primero validar si la clase puede ser eliminada
    try {
      const response = await axios.get(`${API}/clases/${clase.id}/validar-eliminacion`);
      setValidacionEliminacion(response.data);
      setSelectedClaseForAction(clase);
      setIsEliminarModalOpen(true);
    } catch (error) {
      console.error('Error validando eliminación:', error);
      toast.error(formatBackendError(error) || 'Error al validar eliminación de clase');
    }
  };
  
  const handleDuplicarClase = async (clase) => {
    setSelectedClaseForAction(clase);
    setIsDuplicarModalOpen(true);
  };
  
  const handleDesvincularZoom = async (clase) => {
    if (!window.confirm(`¿Estás seguro de desvincular la reunión de Zoom de la clase "${clase.titulo}"?\n\nEsto solo eliminará la asociación, la reunión de Zoom seguirá existiendo.`)) {
      return;
    }
    
    try {
      await axios.put(`${API}/clases/${clase.id}`, {
        ...clase,
        zoom_meeting_id: null,
        zoom_meeting_url: null
      });
      
      toast.success('Zoom desvinculado exitosamente');
      loadClases();
    } catch (error) {
      console.error('Error desvinculando Zoom:', error);
      toast.error(formatBackendError(error) || 'Error al desvincular Zoom');
    }
  };
  
  const abrirModalEstudiantes = async (clase) => {
    setSelectedClaseEstudiantes(clase);
    setShowEstudiantesModal(true);
    setLoadingEstudiantes(true);
    
    try {
      // Obtener detalles de los estudiantes inscritos
      const estudiantesIds = clase.estudiantes_inscritos || [];
      
      if (estudiantesIds.length === 0) {
        setEstudiantesInscritos([]);
        setLoadingEstudiantes(false);
        return;
      }
      
      // Obtener TODOS los usuarios de una sola vez (más eficiente que múltiples llamadas)
      const response = await axios.get(`${API}/users`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      
      const todosLosUsuarios = response.data;
      
      // Filtrar solo los estudiantes inscritos en esta clase
      const estudiantesInscritos = todosLosUsuarios.filter(usuario => 
        estudiantesIds.includes(usuario.id)
      );
      
      // Detectar IDs sin usuario correspondiente
      const idsEncontrados = estudiantesInscritos.map(e => e.id);
      const idsFaltantes = estudiantesIds.filter(id => !idsEncontrados.includes(id));
      
      if (idsFaltantes.length > 0) {
        console.warn('⚠️ IDs de estudiantes inscritos sin usuario correspondiente:', idsFaltantes);
        console.warn(`Total inscripciones: ${estudiantesIds.length}, Usuarios encontrados: ${estudiantesInscritos.length}`);
      }
      
      setEstudiantesInscritos(estudiantesInscritos);
    } catch (error) {
      console.error('Error cargando estudiantes:', error);
      toast.error('Error al cargar la lista de estudiantes');
    } finally {
      setLoadingEstudiantes(false);
    }
  };
  
  const cerrarModalEstudiantes = () => {
    setShowEstudiantesModal(false);
    setSelectedClaseEstudiantes(null);
    setEstudiantesInscritos([]);
  };

  const eliminarEstudianteDeClase = async (estudianteId, estudianteNombre) => {
    if (!window.confirm(`¿Estás seguro que deseas desinscribir a ${estudianteNombre} de esta clase?`)) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${API}/admin/clases/${selectedClaseEstudiantes.id}/estudiantes/${estudianteId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success(`${estudianteNombre} ha sido desinscrito exitosamente`);
      
      // Actualizar la lista de estudiantes en el modal
      setEstudiantesInscritos(prev => prev.filter(e => e.id !== estudianteId));
      
      // Actualizar la clase en la lista principal
      setClases(prev => prev.map(clase => {
        if (clase.id === selectedClaseEstudiantes.id) {
          return {
            ...clase,
            estudiantes_inscritos: clase.estudiantes_inscritos.filter(id => id !== estudianteId)
          };
        }
        return clase;
      }));
      
      // Actualizar la clase seleccionada para el modal
      setSelectedClaseEstudiantes(prev => ({
        ...prev,
        estudiantes_inscritos: prev.estudiantes_inscritos.filter(id => id !== estudianteId)
      }));

    } catch (error) {
      console.error('Error eliminando estudiante:', error);
      toast.error(error.response?.data?.detail || 'Error al desinscribir estudiante');
    }
  };

  const ejecutarDuplicacion = async (formData) => {
    try {
      // Construir query parameters para el backend
      const params = new URLSearchParams({
        nuevo_nombre: formData.nuevoNombre,
        copiar_materiales: formData.copiarMateriales.toString(),
        copiar_formularios: formData.copiarFormularios.toString(),
        copiar_tareas: formData.copiarTareas.toString()
      });
      
      // Agregar parámetros opcionales solo si tienen valor
      if (formData.nuevoAnio) {
        params.append('nuevo_anio', formData.nuevoAnio.toString());
      }
      if (formData.fechaInicio) {
        params.append('fecha_inicio', formData.fechaInicio);
      }
      if (formData.semestreId) {
        params.append('semestre_id', formData.semestreId.toString());
      }
      
      const response = await axios.post(
        `${API}/clases/${selectedClaseForAction.id}/duplicar?${params.toString()}`
      );
      
      toast.success('Clase duplicada exitosamente');
      setIsDuplicarModalOpen(false);
      loadClases(); // Recargar clases
    } catch (error) {
      console.error('Error duplicando clase:', error);
      toast.error(formatBackendError(error) || 'Error al duplicar clase');
    }
  };
  
  const ejecutarEliminacion = async () => {
    setDeleting(true);
    try {
      await axios.delete(`${API}/clases/${selectedClaseForAction.id}`);
      toast.success('Clase duplicada eliminada exitosamente');
      setIsEliminarModalOpen(false);
      loadClases();
    } catch (error) {
      console.error('Error eliminando clase:', error);
      toast.error(formatBackendError(error) || 'Error al eliminar clase');
    } finally {
      setDeleting(false);
    }
  };

  const handleToggleActiva = async (clase) => {
    try {
      const response = await axios.put(`${API}/clases/${clase.id}/toggle-activa`);
      toast.success(response.data.message);
      loadClases(); // Recargar clases
    } catch (error) {
      console.error('Error toggling clase activa:', error);
      toast.error('Error al cambiar estado de la clase');
    }
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('La imagen debe ser menor a 5MB');
      return;
    }

    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${API}/upload/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setNewClase({ ...newClase, imagen_url: response.data.imagen_url });
      toast.success('Imagen subida exitosamente');
    } catch (error) {
      toast.error('Error al subir la imagen');
    } finally {
      setUploadingImage(false);
    }
  };

  const handleBannerUpload = async (event, isEdit = false) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file size (max 10MB for banners)
    if (file.size > 10 * 1024 * 1024) {
      toast.error('El banner debe ser menor a 10MB');
      return;
    }

    // Check admin permissions
    if (user.rol !== 'admin') {
      toast.error('Solo administradores pueden subir banners');
      return;
    }

    setUploadingBanner(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${API}/upload/class-banner`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (isEdit) {
        setEditForm({ ...editForm, banner_url: response.data.banner_url });
      } else {
        setNewClase({ ...newClase, banner_url: response.data.banner_url });
      }
      
      toast.success('Banner subido exitosamente');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al subir el banner');
    } finally {
      setUploadingBanner(false);
    }
  };

  const handleDayToggle = (day) => {
    const updatedDays = newClase.dias_semana.includes(day)
      ? newClase.dias_semana.filter(d => d !== day)
      : [...newClase.dias_semana, day];
    
    setNewClase({ ...newClase, dias_semana: updatedDays });
  };

  const handleEditDayToggle = (day) => {
    const currentDays = editForm.dias_semana || [];
    const updatedDays = currentDays.includes(day)
      ? currentDays.filter(d => d !== day)
      : [...currentDays, day];
    
    setEditForm({ ...editForm, dias_semana: updatedDays });
  };

  const handleInscribirse = async (claseId, clase) => {
    // Verificar si el estudiante puede inscribirse antes de intentar
    if (isStudentRole(user.rol) && !puedeInscribirse(clase)) {
      toast.error(getMensajeNoInscripcion(clase));
      return;
    }
    
    try {
      await axios.post(`${API}/clases/${claseId}/inscribir`);
      await loadClases();
      toast.success('¡Te has inscrito exitosamente!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al inscribirse');
    }
  };

  const handleDesinscribirse = async (claseId) => {
    try {
      await axios.post(`${API}/clases/${claseId}/desinscribir`);
      await loadClases();
      toast.success('Te has desinscrito exitosamente');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al desinscribirse');
    }
  };


  // Función para verificar si el estudiante puede inscribirse a una clase
  const puedeInscribirse = (clase) => {
    // Si no es estudiante, usar lógica original
    if (!isStudentRole(user.rol)) return true;
    
    // Si no hay semestres asignados a la clase, puede inscribirse
    if (!clase.semestres || clase.semestres.length === 0) return true;
    
    // Verificar si al menos uno de los semestres de la clase está en los semestres pagados
    return clase.semestres.some(sem => semestresPagados.includes(sem));
  };
  
  // Función para obtener mensaje de por qué no puede inscribirse
  const getMensajeNoInscripcion = (clase) => {
    if (!clase.semestres || clase.semestres.length === 0) {
      return '';
    }
    
    const semestresClaseNombres = clase.semestres
      .map(sem => getSemestreNombre(sem))
      .join(', ');
    
    return `Para inscribirte a esta clase, debes renovar tu matrícula para: ${semestresClaseNombres}`;
  };

  // Función para convertir fecha UTC a hora local de Montevideo
  const convertUTCToMontevideo = (utcDateString) => {
    if (!utcDateString) return '';
    
    try {
      console.log('🔍 DEBUG Frontend - Fecha UTC recibida del backend:', utcDateString);
      
      // Si la fecha NO tiene Z al final, agregarla para que se interprete como UTC
      let dateStr = utcDateString;
      if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
        dateStr = dateStr + 'Z';
        console.log('🔍 DEBUG Frontend - Agregada Z para interpretarlo como UTC:', dateStr);
      }
      
      // Parsear la fecha UTC que viene del backend
      const utcDate = new Date(dateStr);
      console.log('🔍 DEBUG Frontend - Fecha parseada como Date:', utcDate.toISOString());
      
      // Convertir a hora de Montevideo (UTC-3)
      // Restar 3 horas del tiempo UTC
      const montevideoTime = new Date(utcDate.getTime() - (3 * 60 * 60 * 1000));
      console.log('🔍 DEBUG Frontend - Después de restar 3 horas:', montevideoTime.toISOString());
      
      // Formatear manualmente para evitar conversión automática del navegador
      // Usamos getUTC* porque ya ajustamos el tiempo manualmente
      const year = montevideoTime.getUTCFullYear();
      const month = String(montevideoTime.getUTCMonth() + 1).padStart(2, '0');
      const day = String(montevideoTime.getUTCDate()).padStart(2, '0');
      const hours = String(montevideoTime.getUTCHours()).padStart(2, '0');
      const minutes = String(montevideoTime.getUTCMinutes()).padStart(2, '0');
      
      const result = `${year}-${month}-${day}T${hours}:${minutes}`;
      console.log('🔍 DEBUG Frontend - Resultado final para el input:', result);
      
      // Retornar en formato que datetime-local espera
      return result;
    } catch (error) {
      console.error('Error converting date:', error);
      return '';
    }
  };

  const formatDateTime = (dateTimeString) => {
    try {
      // Convertir UTC a hora de Montevideo para mostrar
      const utcDate = new Date(dateTimeString);
      // Montevideo está UTC-3, RESTAR 3 horas para mostrar hora local
      const montevideoDate = new Date(utcDate.getTime() - (3 * 60 * 60 * 1000));
      return montevideoDate.toLocaleDateString('es-UY', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // Formato 24 horas como solicitó el usuario
      });
    } catch {
      return 'Fecha inválida';
    }
  };

  const formatDate = formatDateTime; // Usar la nueva función con timezone

  // Función para formatear errores de validación del backend
  const formatBackendError = (error) => {
    if (!error.response?.data?.detail) {
      return 'Error desconocido';
    }

    const detail = error.response.data.detail;
    
    // Si es una lista de errores de Pydantic
    if (Array.isArray(detail)) {
      return detail.map(err => `${err.loc?.join('.') || 'Campo'}: ${err.msg}`).join(', ');
    }
    
    // Si es un string
    if (typeof detail === 'string') {
      return detail;
    }
    
    // Si es un objeto con mensaje
    if (detail.msg) {
      return detail.msg;
    }
    
    return JSON.stringify(detail);
  };

  const isInscrito = (clase) => {
    return clase.estudiantes_inscritos?.includes(user.id);
  };

  // Funciones para asistencias
  const abrirModalAsistencia = (clase) => {
    setClaseAsistenciaSeleccionada(clase);
    setShowAsistenciaModal(true);
  };

  // Función para abrir modal de QR de asistencia presencial
  const abrirModalQR = (clase) => {
    setSelectedClaseQR(clase);
    setShowQRModal(true);
  };


  const abrirVerificacionCamara = async () => {
    try {
      setShowAsistenciaModal(false);
      setShowCameraCheck(true);
      setCameraError(null);
      
      // Verificar si el navegador soporta getUserMedia
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraError('no-supported');
        return;
      }
      
      // Solicitar acceso a la cámara (resolución reducida para móviles)
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { width: 480, height: 360 }, 
        audio: false 
      });
      
      setCameraStream(stream);
      
      // Asignar stream al video element
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error('Error accessing camera:', error);
      
      // Determinar el tipo de error
      if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        setCameraError('no-camera');
      } else if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        setCameraError('permission-denied');
      } else {
        setCameraError('unknown');
      }
    }
  };

  const detenerCamara = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
      setCameraStream(null);
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const confirmarYMarcarAsistencia = async () => {
    detenerCamara();
    setShowCameraCheck(false);
    await marcarAsistencia(claseAsistenciaSeleccionada.id, true);
  };

  const cancelarVerificacionCamara = () => {
    detenerCamara();
    setShowCameraCheck(false);
    setShowAsistenciaModal(true);
  };

  const marcarAsistencia = async (claseId, presente) => {
    setMarcandoAsistencia(prev => ({ ...prev, [claseId]: true }));
    
    try {
      // Marcando asistencia
      
      await axios.post(`${API}/asistencias/marcar`, {
        clase_id: claseId,
        presente: presente
      });
      
      const estadoTexto = presente ? 'presente' : 'ausente';
      toast.success(`Asistencia marcada como ${estadoTexto} exitosamente`);
      
      // Cerrar modal de asistencia
      setShowAsistenciaModal(false);
      setClaseAsistenciaSeleccionada(null);
      
      // Si marcó presente y la clase tiene Zoom, mostrar acceso rápido
      if (presente && claseAsistenciaSeleccionada && claseAsistenciaSeleccionada.zoom_link) {
        setClaseZoomAcceso(claseAsistenciaSeleccionada);
        setShowZoomAccess(true);
      }
      
      // Si están viendo las asistencias de esta clase, refrescar
      if (selectedClaseAsistencias && selectedClaseAsistencias.id === claseId) {
        loadAsistenciasClase(selectedClaseAsistencias);
      }
    } catch (error) {
      console.error('Error marking attendance:', error);
      toast.error(formatBackendError(error) || 'Error al marcar asistencia');
    } finally {
      setMarcandoAsistencia(prev => ({ ...prev, [claseId]: false }));
    }
  };

  const loadAsistenciasClase = async (clase) => {
    setLoadingAsistencias(true);
    try {
      const response = await axios.get(`${API}/asistencias/clase/${clase.id}`);
      setAsistencias(response.data);
      setSelectedClaseAsistencias(clase);
      setShowAsistencias(true);
    } catch (error) {
      console.error('Error loading attendance:', error);
      toast.error('Error al cargar asistencias');
    } finally {
      setLoadingAsistencias(false);
    }
  };

  const exportarAsistencias = async (claseId = null) => {
    try {
      const url = `${API}/admin/backups?export_asistencias=excel`;
        
      const response = await axios.get(url, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params: {
          authorization: localStorage.getItem('token')
        }
      });
      
      // Crear enlace de descarga
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      const url2 = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url2;
      
      const fecha = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      link.download = `Asistencias_${fecha}.xlsx`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url2);
      
      toast.success('Archivo exportado exitosamente');
    } catch (error) {
      console.error('Error exporting attendance:', error);
      toast.error('Error al exportar asistencias');
    }
  };

  const esClaseDeHoy = (clase) => {
    // Usar la misma lógica de zona horaria que el backend (Montevideo UTC-3)
    const hoyUTC = new Date();
    const hoyMontevideo = new Date(hoyUTC.getTime() - (3 * 60 * 60 * 1000)); // Restar 3 horas para Montevideo
    
    const fechaInicio = new Date(clase.fecha_inicio);
    const fechaFin = new Date(clase.fecha_fin);
    
    console.log(`🔍 DEBUG esClaseDeHoy para: ${clase.titulo}`);
    console.log(`  Hoy Montevideo: ${hoyMontevideo.toLocaleDateString()}`);
    console.log(`  Fecha inicio: ${fechaInicio.toLocaleDateString()}`);
    console.log(`  Fecha fin: ${fechaFin.toLocaleDateString()}`);
    console.log(`  Días semana: ${JSON.stringify(clase.dias_semana)}`);
    
    // Verificar que estamos dentro del rango de fechas del semestre
    if (hoyMontevideo < fechaInicio || hoyMontevideo > fechaFin) {
      console.log(`  ❌ Fuera de rango de fechas`);
      return false;
    }
    
    // Verificar que hoy sea uno de los días de la semana seleccionados
    const diasSemanaMap = {
      'sunday': 'domingo',
      'monday': 'lunes', 
      'tuesday': 'martes',
      'wednesday': 'miércoles',
      'thursday': 'jueves',
      'friday': 'viernes',
      'saturday': 'sábado'
    };
    
    // Usar fecha de Montevideo para obtener el día de la semana
    const diaHoyIngles = hoyMontevideo.toLocaleDateString('en', { weekday: 'long' }).toLowerCase();
    const diaHoyEspanol = diasSemanaMap[diaHoyIngles];
    
    console.log(`  Día hoy: ${diaHoyEspanol}`);
    console.log(`  ¿Incluye día?: ${clase.dias_semana && clase.dias_semana.includes(diaHoyEspanol)}`);
    
    return clase.dias_semana && clase.dias_semana.includes(diaHoyEspanol);
  };

  const yaMarcoAsistenciaHoy = async (claseId) => {
    try {
      const response = await axios.get(`${API}/asistencias/clase/${claseId}`);
      const hoy = new Date().toISOString().split('T')[0];
      
      return response.data.some(asistencia => {
        const fechaAsistencia = new Date(asistencia.fecha).toISOString().split('T')[0];
        return fechaAsistencia === hoy && asistencia.usuario_id === user.id;
      });
    } catch (error) {
      return false;
    }
  };
  
  // Función para obtener años únicos de las clases
  const getAñosUnicos = () => {
    const años = clases
      .filter(clase => clase.fecha_inicio)
      .map(clase => new Date(clase.fecha_inicio).getFullYear())
      .filter((año, index, self) => self.indexOf(año) === index)
      .sort((a, b) => b - a); // Ordenar descendente (más reciente primero)
    return años;
  };
  
  // Función para filtrar clases
  const filtrarClases = () => {
    return clases.filter(clase => {
      // Filtro por estado (activa/inactiva)
      if (filtroActiva === 'activas' && !clase.activa) return false;
      if (filtroActiva === 'inactivas' && clase.activa) return false;
      
      // Filtro por semestre
      if (filtroSemestre !== 'todos') {
        const semestreId = parseInt(filtroSemestre);
        if (!clase.semestres || !clase.semestres.includes(semestreId)) return false;
      }
      
      // Filtro por año (usar fecha_inicio)
      if (filtroAño !== 'todos') {
        if (!clase.fecha_inicio) return false; // Si no tiene fecha_inicio, no la incluye
        const añoClase = new Date(clase.fecha_inicio).getFullYear();
        if (añoClase !== parseInt(filtroAño)) return false;
      }
      
      // Filtro por estado de registro (solo para estudiantes)
      if (isStudentRole(user?.rol) && filtroRegistro !== 'todos') {
        const estaInscrito = clase.estudiantes_inscritos?.includes(user.id);
        if (filtroRegistro === 'registrado' && !estaInscrito) return false;
        if (filtroRegistro === 'sin_registrar' && estaInscrito) return false;
      }
      
      return true;
    });
  };
  
  const clasesFiltradas = filtrarClases().sort((a, b) => {
    // Ordenar: primero clases donde soy PROFESOR, luego clases donde soy ESTUDIANTE
    const soyProfesorA = a.profesor_id === user?.id;
    const soyProfesorB = b.profesor_id === user?.id;
    
    if (soyProfesorA && !soyProfesorB) return -1; // A es profesor, va primero
    if (!soyProfesorA && soyProfesorB) return 1;  // B es profesor, va primero
    return 0; // Mismo tipo, mantener orden
  });

  if (loading) {
    return (
      <div className="space-y-6">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/3 mb-6"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-64 bg-gray-200 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8" data-testid="clases-page">
      {/* Banner especial para profesores en capacitación */}
      {user.rol === 'profesor' && user.capacitado === false && (
        <Card className="border-4 border-orange-500 bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-50 shadow-2xl">
          <CardContent className="p-8">
            <div className="flex flex-col items-center text-center space-y-6">
              {/* Logo */}
              <div className="relative">
                <img
                  src={process.env.REACT_APP_LOGO_URL || "/logo-iba.jpg"}
                  alt="Instituto Logo"
                  className="h-24 w-auto drop-shadow-2xl"
                />
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-orange-500 rounded-full border-4 border-white animate-pulse"></div>
              </div>
              
              {/* Título */}
              <div>
                <h1 className="text-4xl font-bold text-gray-900 mb-2">
                  Instituto Bíblico Apostólico del Uruguay
                </h1>
                <div className="flex items-center justify-center gap-2 text-orange-700">
                  <i className="fas fa-graduation-cap text-2xl"></i>
                  <span className="text-xl font-semibold">Programa de Capacitación para Profesores</span>
                </div>
              </div>
              
              {/* Mensaje */}
              <div className="bg-white rounded-xl p-6 shadow-lg max-w-2xl border-2 border-orange-200">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <i className="fas fa-exclamation text-white text-xl"></i>
                  </div>
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Bienvenido, {user.nombre} {user.apellido}
                    </h3>
                    <p className="text-gray-700 mb-4">
                      Para poder acceder al sistema completo del instituto, debes completar <strong className="text-orange-700">obligatoriamente</strong> la <strong className="text-orange-700">Auto-Capacitación en IBA Connect para Profesores</strong>.
                    </p>
                    <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-500">
                      <p className="text-sm font-semibold text-orange-900 mb-2">
                        <i className="fas fa-clipboard-list mr-2"></i>
                        Instrucciones:
                      </p>
                      <ol className="text-sm text-gray-700 space-y-1 list-decimal list-inside">
                        <li>Completá las pruebas autocalificables que aparecen abajo</li>
                        <li>Revisá los videos y materiales de cada lección</li>
                        <li>Obtené la calificación mínima requerida en cada prueba</li>
                        <li>Un administrador activará tu cuenta al finalizar</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Badge de estado */}
              <Badge className="bg-orange-600 text-white text-lg px-6 py-2">
                <i className="fas fa-hourglass-half mr-2"></i>
                Estado: Pendiente de Capacitación
              </Badge>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Widget de Pruebas y Exámenes embebido para Auto-Capacitación de profesores */}
      {user.rol === 'profesor' && user.capacitado === false && autoCapClase?.id && (
        <div
          className="bg-white rounded-2xl shadow-xl border-2 border-orange-300 p-4 sm:p-6"
          data-testid="auto-capacitacion-pruebas-widget"
        >
          <div className="flex items-center gap-2 mb-4">
            <span className="text-2xl">📝</span>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
              Pruebas de {autoCapClase.titulo || autoCapClase.nombre}
            </h2>
          </div>
          <PruebasExamenes claseIdProp={autoCapClase.id} embedded />
        </div>
      )}

      {/* Para profesores no calificados solo mostramos cartel + pruebas arriba.
          NO mostramos abajo el listado de clases, ficha de inscripción, etc.
          (confunde, porque ya están inscriptos en la única clase que les
          corresponde — la de auto-capacitación). */}
      {user.rol === 'profesor' && user.capacitado === false ? null : (
      <>
      
      {/* Banner de Estado de Matrícula para Estudiantes */}
      {isStudentRole(user.rol) && estadoMatricula && (
        <Card className={`border-2 ${estadoMatricula.tiene_pago_activo ? 'border-green-500 bg-green-50' : 'border-orange-500 bg-orange-50'}`}>
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <div className={`flex-shrink-0 w-12 h-12 ${estadoMatricula.tiene_pago_activo ? 'bg-green-500' : 'bg-orange-500'} rounded-full flex items-center justify-center`}>
                <i className={`fas ${estadoMatricula.tiene_pago_activo ? 'fa-check' : 'fa-exclamation-triangle'} text-white text-xl`}></i>
              </div>
              <div className="flex-1">
                <h3 className={`text-lg font-bold ${estadoMatricula.tiene_pago_activo ? 'text-green-900' : 'text-orange-900'} mb-2`}>
                  {estadoMatricula.tiene_pago_activo ? '✓ Tu matrícula está al día' : '⚠ Matrícula Pendiente'}
                </h3>
                {estadoMatricula.tiene_pago_activo ? (
                  <div>
                    <p className="text-gray-700 mb-2">
                      Estás matriculado en los siguientes semestres:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {estadoMatricula.semestres_pagados_detalle.map((sem, idx) => (
                        <Badge key={idx} className="bg-green-600 text-white">
                          <i className="fas fa-graduation-cap mr-1"></i>
                          {sem.nombre}
                        </Badge>
                      ))}
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      Puedes inscribirte a todas las clases de estos semestres.
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="text-gray-700 mb-3">
                      Para poder inscribirte a clases, debes renovar tu matrícula semestral.
                    </p>
                    <Button
                      onClick={() => window.location.href = '/app/registraciones'}
                      className="bg-orange-600 hover:bg-orange-700 text-white"
                    >
                      <i className="fas fa-arrow-right mr-2"></i>
                      Ir a Renovar Matrícula
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          <Button 
            variant="ghost" 
            onClick={() => window.history.length > 2 ? window.history.back() : window.location.href = '/app/dashboard'}
            className="text-gray-600 hover:text-gray-800"
            data-testid="back-button"
          >
            <i className="fas fa-arrow-left mr-2"></i>
            Volver
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Clases</h1>
            <p className="text-gray-600">Gestiona y participa en las clases del instituto</p>
          </div>
        </div>
        
        <div className="flex gap-2 mt-4 lg:mt-0">
          {/* Botón para limpiar TODOS los datos de Zoom - Solo Admin */}
          {user.rol === 'admin' && (
            <Button 
              variant="outline"
              className="text-orange-600 hover:text-orange-700 border-orange-300"
              onClick={async () => {
                if (!window.confirm('¿Limpiar datos de Zoom de TODAS las clases?\n\nEsto NO borra las reuniones en Zoom, solo limpia los datos en IBA Connect.\n\nÚsalo si ya borraste las reuniones directamente en Zoom.')) {
                  return;
                }
                try {
                  const response = await axios.post(`${API}/admin/clases/clear-all-zoom-data`);
                  if (response.data.success) {
                    toast.success(`✅ ${response.data.message}`);
                    await loadClases();
                  }
                } catch (error) {
                  toast.error(error.response?.data?.detail || 'Error al limpiar datos');
                }
              }}
            >
              <i className="fas fa-broom mr-2"></i>
              Limpiar Zoom de Todas
            </Button>
          )}
          
          {(user.rol === 'admin' || user.rol === 'profesor') && (
          <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
              <Button className="instituto-gradient btn-hover text-white" data-testid="create-clase-button">
                <i className="fas fa-plus mr-2"></i>
                Nueva Clase
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Crear Nueva Clase</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleCreateClase} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="titulo">Título *</Label>
                  <Input
                    id="titulo"
                    value={newClase.titulo}
                    onChange={(e) => setNewClase({ ...newClase, titulo: e.target.value })}
                    placeholder="Título de la clase"
                    required
                    data-testid="clase-titulo-input"
                  />
                </div>
                
                <div className="space-y-2">
                  <Label htmlFor="categoria">Categoría *</Label>
                  <Select value={newClase.categoria} onValueChange={(value) => setNewClase({ ...newClase, categoria: value })}>
                    <SelectTrigger data-testid="clase-categoria-select">
                      <SelectValue placeholder="Selecciona la audiencia" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="estudiantes">Para Estudiantes (estudiantes pueden inscribirse)</SelectItem>
                      <SelectItem value="profesores">Para Profesores (solo profesores y administradores)</SelectItem>
                      <SelectItem value="devocional">Devocional (abierto a todos los roles)</SelectItem>
                      <SelectItem value="autocapacitacion">Auto-Capacitación (Estudiantes) — se compra desde Registración</SelectItem>
                      <SelectItem value="autocapacitacion_profesores">Auto-Capacitación (Profesores) — admin la asigna</SelectItem>
                    </SelectContent>
                  </Select>
                  <p className="text-xs text-gray-500">
                    {newClase.categoria === 'estudiantes' 
                      ? 'Esta clase será visible para todos y los estudiantes podrán inscribirse' 
                      : newClase.categoria === 'devocional'
                      ? 'Esta clase será visible para todos los usuarios de cualquier rol'
                      : newClase.categoria === 'autocapacitacion'
                      ? 'Auto-estudio orientado a ESTUDIANTES. Aparece en el flujo de Registración para que el estudiante la compre.'
                      : newClase.categoria === 'autocapacitacion_profesores'
                      ? 'Auto-estudio orientado a PROFESORES. NO aparece en el flujo de compra; el administrador asigna los profesores directamente.'
                      : 'Esta clase solo será visible para profesores y administradores'}
                  </p>
                </div>
                
                {/* Checkboxes para tipo de clase especial */}
                <div className="space-y-3 p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg border border-purple-200">
                  <Label className="text-purple-800 font-semibold">Tipo de Clase Especial</Label>
                  
                  <div className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      id="es_ministerial"
                      checked={newClase.es_ministerial}
                      onChange={(e) => setNewClase({ ...newClase, es_ministerial: e.target.checked })}
                      className="h-5 w-5 rounded border-purple-300 text-purple-600 mt-0.5"
                    />
                    <div>
                      <Label htmlFor="es_ministerial" className="font-medium cursor-pointer text-purple-900">
                        ⛪ Clase Ministerial
                      </Label>
                      <p className="text-xs text-purple-700">
                        Clase de formación ministerial para servicio en la iglesia
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      id="es_extracurricular"
                      checked={newClase.es_extracurricular}
                      onChange={(e) => setNewClase({ ...newClase, es_extracurricular: e.target.checked })}
                      className="h-5 w-5 rounded border-orange-300 text-orange-600 mt-0.5"
                    />
                    <div>
                      <Label htmlFor="es_extracurricular" className="font-medium cursor-pointer text-orange-900">
                        📚 Clase Extracurricular
                      </Label>
                      <p className="text-xs text-orange-700">
                        Clase adicional fuera del currículum regular del semestre
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      id="es_abierta"
                      checked={newClase.es_abierta}
                      onChange={(e) => setNewClase({ ...newClase, es_abierta: e.target.checked })}
                      className="h-5 w-5 rounded border-green-300 text-green-600 mt-0.5"
                    />
                    <div>
                      <Label htmlFor="es_abierta" className="font-medium cursor-pointer text-green-900">
                        🔓 Clase Abierta
                      </Label>
                      <p className="text-xs text-green-700">
                        Pastores y Graduados pueden inscribirse sin necesidad de pagar semestre
                      </p>
                    </div>
                  </div>
                </div>

                {/* Modalidad de la clase: Vivo (Zoom) o Grabada (video) */}
                <div className="p-4 bg-gradient-to-br from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-lg space-y-2">
                  <Label htmlFor="modalidad" className="font-semibold text-indigo-900">
                    📼 Modalidad de la Clase
                  </Label>
                  <select
                    id="modalidad"
                    value={newClase.modalidad}
                    onChange={(e) => setNewClase({ ...newClase, modalidad: e.target.value })}
                    className="w-full px-3 py-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                    data-testid="new-clase-modalidad"
                  >
                    <option value="vivo">🎥 Vivo (Zoom en vivo)</option>
                    <option value="grabada">📼 Grabada (video pregrabado)</option>
                  </select>
                  <p className="text-xs text-indigo-700">
                    {newClase.modalidad === 'grabada'
                      ? 'El estudiante irá a "Videos de Clases" el día de clase (asistencia se marca igual).'
                      : 'El estudiante entra a Zoom el día y hora de la clase.'}
                  </p>
                </div>
                
                <div className="space-y-2">
                  <Label>Semestres * (Selecciona uno o más)</Label>
                  <div className="grid grid-cols-2 gap-3">
                    {semestresActivos.map(sem => (
                      <div key={sem} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          id={`semestre-${sem}`}
                          checked={newClase.semestres.includes(sem)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setNewClase({ ...newClase, semestres: [...newClase.semestres, sem] });
                            } else {
                              setNewClase({ ...newClase, semestres: newClase.semestres.filter(s => s !== sem) });
                            }
                          }}
                          className="h-4 w-4 rounded border-gray-300"
                        />
                        <Label htmlFor={`semestre-${sem}`} className="font-normal cursor-pointer">
                          {getSemestreNombre(sem)}
                        </Label>
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">
                    Selecciona en qué semestres académicos se impartirá esta clase. {user?.rol === 'admin' ? `Mostrando todos los semestres (${semestresActivos.length})` : `Mostrando semestres activos (${semestresActivos.length})`}
                  </p>
                </div>
                
                {/* Selector de profesor - solo para administradores */}
                {user.rol === 'admin' && (
                  <div className="space-y-2">
                    <Label htmlFor="profesor">Profesor Asignado</Label>
                    <Select 
                      value={newClase.profesor_id} 
                      onValueChange={(value) => setNewClase({ ...newClase, profesor_id: value })}
                    >
                      <SelectTrigger data-testid="clase-profesor-select">
                        <SelectValue placeholder="Selecciona un profesor (opcional)" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="auto">Sin asignación específica (se asigna a ti)</SelectItem>
                        {profesores.map((profesor) => (
                          <SelectItem key={profesor.id} value={profesor.id}>
                            {profesor.nombre} {profesor.apellido} ({profesor.rol})
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <p className="text-xs text-gray-500">
                      Como administrador, puedes asignar esta clase a cualquier profesor. Si no seleccionas ninguno, se asignará a ti.
                    </p>
                  </div>
                )}
                
                <div className="space-y-2">
                  <Label htmlFor="descripcion">Descripción *</Label>
                  <Textarea
                    id="descripcion"
                    value={newClase.descripcion}
                    onChange={(e) => setNewClase({ ...newClase, descripcion: e.target.value })}
                    placeholder="Descripción de la clase"
                    rows={3}
                    required
                    data-testid="clase-descripcion-input"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="imagen">Imagen Identificativa</Label>
                  <div className="flex flex-col space-y-2">
                    <input
                      id="imagen"
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      disabled={uploadingImage}
                      className="file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      data-testid="clase-imagen-input"
                    />
                    {uploadingImage && (
                      <div className="text-sm text-gray-500">
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Subiendo imagen...
                      </div>
                    )}
                    {newClase.imagen_url && (
                      <div className="mt-2">
                        <img 
                          src={getImageUrl(newClase.imagen_url)} 
                          alt="Previsualización" 
                          className="h-20 w-20 object-cover rounded-lg border"
                          onError={(e) => {
                            console.error('Error loading image preview:', newClase.imagen_url);
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Banner Upload - Solo para administradores */}
                {user.rol === 'admin' && (
                  <div className="space-y-3">
                    <Label className="text-base font-semibold">
                      <i className="fas fa-image mr-2 text-green-600"></i>
                      Banner de Clase
                    </Label>
                    
                    {/* Preview del Banner */}
                    {newClase.banner_url && (
                      <div className="mb-3">
                        <div className="flex items-center space-x-2 mb-2">
                          <Badge className="bg-green-600 text-white text-xs">
                            <i className="fas fa-check mr-1"></i>
                            Banner configurado
                          </Badge>
                        </div>
                        <img 
                          src={newClase.banner_url.startsWith('http') ? newClase.banner_url : getImageUrl(newClase.banner_url)} 
                          alt="Banner Preview" 
                          className="h-24 w-auto max-w-full object-cover rounded-lg border-2 border-green-200"
                          onError={(e) => {
                            console.error('Error loading banner preview:', newClase.banner_url);
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                    
                    {/* Opción 1: Subir desde PC */}
                    <div>
                      <Label className="text-sm font-medium text-gray-700 mb-2 block">
                        <i className="fas fa-upload mr-2"></i>
                        Opción 1: Subir desde PC
                      </Label>
                      <input
                        id="banner"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleBannerUpload(e, false)}
                        disabled={uploadingBanner}
                        className="file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100 w-full"
                        data-testid="clase-banner-input"
                      />
                      {uploadingBanner && (
                        <div className="text-sm text-gray-500 mt-2">
                          <i className="fas fa-spinner fa-spin mr-2"></i>
                          Subiendo banner...
                        </div>
                      )}
                      <p className="text-xs text-gray-500 mt-2">
                        <i className="fas fa-info-circle mr-1"></i>
                        Formato: JPG, PNG. Tamaño recomendado: 1920x400px
                      </p>
                    </div>
                    
                    {/* Divisor */}
                    <div className="relative">
                      <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-300"></div>
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white text-gray-500">O</span>
                      </div>
                    </div>
                    
                    {/* Opción 2: URL Externa */}
                    <div>
                      <Label className="text-sm font-medium text-gray-700 mb-2 block">
                        <i className="fas fa-link mr-2"></i>
                        Opción 2: URL de Imagen Externa (Imgur, etc.)
                      </Label>
                      <Input
                        type="url"
                        placeholder="https://i.imgur.com/ejemplo.jpg"
                        value={newClase.banner_url || ''}
                        onChange={(e) => setNewClase({ ...newClase, banner_url: e.target.value })}
                        className="w-full"
                      />
                      <p className="text-xs text-gray-500 mt-2">
                        <i className="fas fa-info-circle mr-1"></i>
                        Pega aquí la URL completa de una imagen desde Imgur u otro servicio
                      </p>
                    </div>
                  </div>
                )}

                <div className="space-y-2">
                  <Label>Días de la Semana *</Label>
                  <div className="grid grid-cols-2 gap-2">
                    {['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'].map((day) => (
                      <label key={day} className="flex items-center space-x-2 p-2 rounded border hover:bg-gray-50">
                        <input
                          type="checkbox"
                          checked={newClase.dias_semana.includes(day)}
                          onChange={() => handleDayToggle(day)}
                          className="rounded text-blue-600"
                        />
                        <span className="capitalize text-sm">{day}</span>
                      </label>
                    ))}
                  </div>
                </div>
                
                <div className="space-y-2">
                  <Label htmlFor="zoom_link">Link de Zoom (opcional)</Label>
                  <Input
                    id="zoom_link"
                    type="url"
                    value={newClase.zoom_link}
                    onChange={(e) => setNewClase({ ...newClase, zoom_link: e.target.value })}
                    placeholder="https://zoom.us/j/..."
                    data-testid="clase-zoom-input"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="playlist_youtube">Playlist de YouTube (opcional)</Label>
                  <Input
                    id="playlist_youtube"
                    type="url"
                    value={newClase.playlist_youtube || ''}
                    onChange={(e) => setNewClase({ ...newClase, playlist_youtube: e.target.value })}
                    placeholder="https://www.youtube.com/playlist?list=..."
                    data-testid="clase-playlist-input"
                  />
                  <p className="text-xs text-gray-500">
                    URL de playlist con los videos de clases anteriores
                  </p>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label htmlFor="fecha_inicio">Fecha y Hora de Inicio * (Hora de Uruguay UTC-3)</Label>
                    <Input
                      id="fecha_inicio"
                      type="datetime-local"
                      value={newClase.fecha_inicio}
                      onChange={(e) => setNewClase({ ...newClase, fecha_inicio: e.target.value })}
                      required
                      data-testid="clase-fecha-inicio-input"
                    />
                    <p className="text-xs text-blue-600">🇺🇾 Ingrese la hora en formato de 24 horas (Uruguay, UTC-3)</p>
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="fecha_fin">Fecha y Hora de Fin * (Hora de Uruguay UTC-3)</Label>
                    <Input
                      id="fecha_fin"
                      type="datetime-local"
                      value={newClase.fecha_fin}
                      onChange={(e) => setNewClase({ ...newClase, fecha_fin: e.target.value })}
                      required
                      data-testid="clase-fecha-fin-input"
                    />
                    <p className="text-xs text-blue-600">🇺🇾 Ingrese la hora en formato de 24 horas (Uruguay, UTC-3)</p>
                  </div>
                </div>

                {/* Selector de Reunión de Zoom - Solo Admin */}
                {user.rol === 'admin' && (
                  <div className="space-y-2 border-t pt-4">
                    <Label htmlFor="zoom_meeting">
                      🎥 Reunión de Zoom (Opcional)
                    </Label>
                    {loadingZoomMeetings ? (
                      <div className="text-sm text-gray-500 py-2">
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Cargando reuniones de Zoom...
                      </div>
                    ) : zoomMeetings.length === 0 ? (
                      <div className="text-sm text-yellow-600 bg-yellow-50 px-3 py-2 rounded border border-yellow-300">
                        ⚠️ No hay reuniones de Zoom disponibles. Crea reuniones en Zoom primero o ve a &quot;Sistema → Gestión de Zoom&quot; para sincronizar.
                      </div>
                    ) : (
                      <>
                        <Select 
                          value={newClase.zoom_meeting_id ? String(newClase.zoom_meeting_id) : 'sin-zoom'} 
                          onValueChange={(value) => {
                            if (value && value !== 'sin-zoom') {
                              const meeting = zoomMeetings.find(m => String(m.id) === value);
                              if (meeting) {
                                setNewClase({
                                  ...newClase,
                                  zoom_meeting_id: meeting.id,
                                  zoom_join_url: meeting.join_url,
                                  zoom_start_url: meeting.start_url,
                                  zoom_topic: meeting.topic
                                });
                              }
                            } else {
                              setNewClase({
                                ...newClase,
                                zoom_meeting_id: null,
                                zoom_join_url: '',
                                zoom_start_url: '',
                                zoom_topic: ''
                              });
                            }
                          }}
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Seleccionar reunión de Zoom (opcional)" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="sin-zoom">Sin reunión de Zoom</SelectItem>
                            {zoomMeetings.map(meeting => (
                              <SelectItem key={meeting.id} value={String(meeting.id)}>
                                {meeting.is_active ? '✅ ' : '⏸️ '}
                                {meeting.topic}
                                {meeting.next_occurrence && ` (${new Date(meeting.next_occurrence).toLocaleDateString('es-UY')})`}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                        <p className="text-xs text-gray-500">
                          Asocia esta clase con una reunión de Zoom. Los estudiantes verán el botón para unirse y el profesor podrá iniciar la clase desde el Dashboard.
                        </p>
                        {newClase.zoom_topic && (
                          <div className="text-xs bg-green-50 text-green-700 px-3 py-2 rounded border border-green-300">
                            ✅ Seleccionado: {newClase.zoom_topic}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
                
                <div className="flex justify-end space-x-3 pt-4">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => setIsDialogOpen(false)}
                    disabled={creating}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className="instituto-gradient text-white"
                    disabled={creating}
                    data-testid="clase-submit-button"
                  >
                    {creating ? (
                      <>Creando... <i className="fas fa-spinner fa-spin ml-2"></i></>
                    ) : (
                      <>Crear Clase <i className="fas fa-check ml-2"></i></>
                    )}
                  </Button>
                </div>
              </form>
            </DialogContent>
          </Dialog>
        )}
        </div>
      </div>

      {/* Filtros Section - Para todos los roles */}
      {clases.length > 0 && (
        <Card className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                <i className="fas fa-filter mr-2 text-blue-600"></i>
                Filtrar Clases
              </h3>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  setFiltroActiva('todas');
                  setFiltroSemestre('todos');
                  setFiltroAño('todos');
                  setFiltroRegistro('todos');
                }}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                <i className="fas fa-redo mr-1"></i>
                Limpiar Filtros
              </Button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Filtro Estado (Activas/Inactivas) - Solo Admin/Profesor */}
              {!isStudentRole(user?.rol) && (
                <div className="space-y-2">
                  <Label className="text-sm font-medium text-gray-700">
                    <i className="fas fa-toggle-on mr-1"></i>
                    Estado
                  </Label>
                  <div className="flex gap-2">
                    <Button
                      variant={filtroActiva === 'todas' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroActiva('todas')}
                      className={`flex-1 ${filtroActiva === 'todas' ? 'bg-blue-600 text-white' : 'bg-white'}`}
                    >
                      Todas
                    </Button>
                    <Button
                      variant={filtroActiva === 'activas' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroActiva('activas')}
                      className={`flex-1 ${filtroActiva === 'activas' ? 'bg-green-600 text-white' : 'bg-white'}`}
                    >
                      <i className="fas fa-check-circle mr-1"></i>
                      Activas
                    </Button>
                    <Button
                      variant={filtroActiva === 'inactivas' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroActiva('inactivas')}
                      className={`flex-1 ${filtroActiva === 'inactivas' ? 'bg-red-600 text-white' : 'bg-white'}`}
                    >
                      <i className="fas fa-times-circle mr-1"></i>
                      Inactivas
                    </Button>
                  </div>
                </div>
              )}

              {/* Filtro Registro (Solo Estudiantes) */}
              {isStudentRole(user?.rol) && (
                <div className="space-y-2">
                  <Label className="text-sm font-medium text-gray-700">
                    <i className="fas fa-user-check mr-1"></i>
                    Mi Registro
                  </Label>
                  <div className="flex gap-2">
                    <Button
                      variant={filtroRegistro === 'todos' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroRegistro('todos')}
                      className={`flex-1 ${filtroRegistro === 'todos' ? 'bg-blue-600 text-white' : 'bg-white'}`}
                    >
                      Todas
                    </Button>
                    <Button
                      variant={filtroRegistro === 'registrado' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroRegistro('registrado')}
                      className={`flex-1 ${filtroRegistro === 'registrado' ? 'bg-green-600 text-white' : 'bg-white'}`}
                    >
                      <i className="fas fa-check mr-1"></i>
                      Registrado
                    </Button>
                    <Button
                      variant={filtroRegistro === 'sin_registrar' ? 'default' : 'outline'}
                      size="sm"
                      onClick={() => setFiltroRegistro('sin_registrar')}
                      className={`flex-1 ${filtroRegistro === 'sin_registrar' ? 'bg-orange-600 text-white' : 'bg-white'}`}
                    >
                      <i className="fas fa-clock mr-1"></i>
                      Sin Registrar
                    </Button>
                  </div>
                </div>
              )}
              
              {/* Filtro Semestre */}
              <div className="space-y-2">
                <Label htmlFor="filtro-semestre" className="text-sm font-medium text-gray-700">
                  <i className="fas fa-graduation-cap mr-1"></i>
                  Semestre
                </Label>
                <Select value={filtroSemestre} onValueChange={setFiltroSemestre}>
                  <SelectTrigger id="filtro-semestre" className="bg-white">
                    <SelectValue placeholder="Todos los semestres" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="todos">Todos los semestres</SelectItem>
                    {semestresActivos.map(sem => (
                      <SelectItem key={sem} value={sem.toString()}>
                        {getSemestreNombre(sem)}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              {/* Filtro Año */}
              <div className="space-y-2">
                <Label htmlFor="filtro-año" className="text-sm font-medium text-gray-700">
                  <i className="fas fa-calendar-alt mr-1"></i>
                  Año
                </Label>
                <Select value={filtroAño} onValueChange={setFiltroAño}>
                  <SelectTrigger id="filtro-año" className="bg-white">
                    <SelectValue placeholder="Todos los años" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="todos">Todos los años</SelectItem>
                    {getAñosUnicos().map(año => (
                      <SelectItem key={año} value={año.toString()}>
                        {año}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
            
            {/* Contador de resultados */}
            <div className="flex items-center justify-between pt-2 border-t border-blue-200">
              <p className="text-sm text-gray-600">
                <i className="fas fa-info-circle mr-1"></i>
                Mostrando <span className="font-semibold text-blue-700">{clasesFiltradas.length}</span> de <span className="font-semibold">{clases.length}</span> clases
              </p>
              {(filtroActiva !== 'todas' || filtroSemestre !== 'todos' || filtroAño !== 'todos') && (
                <Badge className="bg-blue-600 text-white">
                  <i className="fas fa-filter mr-1"></i>
                  Filtros activos
                </Badge>
              )}
            </div>
          </div>
        </Card>
      )}

      {/* Classes Grid */}
      {clasesFiltradas.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clasesFiltradas.map((clase) => (
            <Card key={clase.id} className="card-hover shadow-lg border-0 overflow-hidden">
              {/* Banner de la clase (prioridad) o imagen normal */}
              {(clase.banner_url || clase.imagen_url) && (
                <div className="h-48 w-full overflow-hidden relative">
                  <img 
                    src={clase.banner_url 
                      ? (clase.banner_url.startsWith('http') ? clase.banner_url : getImageUrl(clase.banner_url))
                      : getImageUrl(clase.imagen_url)
                    } 
                    alt={clase.titulo}
                    className="h-full w-full object-cover"
                    onError={(e) => {
                      console.error('Error loading class banner/image:', clase.banner_url || clase.imagen_url);
                      e.target.style.display = 'none';
                    }}
                  />
                  {clase.banner_url && (
                    <div className="absolute top-2 right-2">
                      <Badge className="bg-blue-600 text-white text-xs">
                        <i className="fas fa-image mr-1"></i>
                        Banner
                      </Badge>
                    </div>
                  )}
                </div>
              )}
              
              <CardHeader className={`pb-3 ${
                (clase.banner_url || clase.imagen_url)
                  ? 'pt-4' 
                  : clase.categoria === 'estudiantes'
                    ? 'bg-gradient-to-r from-green-50 to-emerald-50'
                    : 'bg-gradient-to-r from-orange-50 to-amber-50'
              }`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-lg mb-2 text-gray-900 line-clamp-2">
                      {clase.titulo}
                    </CardTitle>
                    
                    {/* Badges de tipo especial de clase */}
                    {(clase.es_ministerial || clase.es_abierta || clase.es_extracurricular) && (
                      <div className="flex flex-wrap gap-2 mb-2">
                        {clase.es_ministerial && (
                          <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-800 text-xs font-medium rounded-full">
                            ⛪ Ministerial
                          </span>
                        )}
                        {clase.es_extracurricular && (
                          <span className="inline-flex items-center px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full">
                            📚 Extracurricular
                          </span>
                        )}
                        {clase.es_abierta && (
                          <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                            🔓 Abierta
                          </span>
                        )}
                      </div>
                    )}
                    
                    {/* Información del profesor */}
                    <div className="bg-gray-50 rounded-lg p-3 mb-3">
                      <div className="flex items-center space-x-3">
                        {clase.profesor_foto ? (
                          <img
                            src={getImageUrl(clase.profesor_foto)}
                            alt="Profesor"
                            className="w-10 h-10 rounded-full object-cover border-2 border-blue-200"
                            onError={(e) => {
                              console.error('Error loading profesor image:', clase.profesor_foto);
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                            {clase.profesor_nombre ? clase.profesor_nombre.split(' ').map(n => n[0]).join('') : '?'}
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-gray-900">
                            <i className="fas fa-chalkboard-teacher mr-1 text-blue-600"></i>
                            {clase.profesor_nombre || 'Sin profesor asignado'}
                          </p>
                          {clase.profesor_email && (
                            <p className="text-xs text-gray-600 truncate">
                              <i className="fas fa-envelope mr-1"></i>
                              {clase.profesor_email}
                            </p>
                          )}
                          {clase.profesor_celular && (
                            <p className="text-xs text-gray-600">
                              <i className="fas fa-phone mr-1"></i>
                              {clase.profesor_celular}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {/* Categoría de la clase */}
                    <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                      <div className="flex items-center gap-2">
                        <Badge 
                          variant="secondary" 
                          className={`text-xs ${
                            clase.categoria === 'estudiantes' 
                              ? 'bg-green-100 text-green-800' 
                              : clase.categoria === 'devocional'
                              ? 'bg-amber-100 text-amber-800'
                              : clase.categoria === 'autocapacitacion'
                              ? 'bg-blue-100 text-blue-800'
                              : clase.categoria === 'autocapacitacion_profesores'
                              ? 'bg-indigo-100 text-indigo-800'
                              : 'bg-orange-100 text-orange-800'
                          }`}
                        >
                          <i className={`${
                            clase.categoria === 'estudiantes' 
                              ? 'fas fa-user-graduate' 
                              : clase.categoria === 'devocional'
                              ? 'fas fa-pray'
                              : clase.categoria === 'autocapacitacion'
                              ? 'fas fa-laptop-code'
                              : clase.categoria === 'autocapacitacion_profesores'
                              ? 'fas fa-chalkboard-teacher'
                              : 'fas fa-users-cog'
                          } mr-1`}></i>
                          {clase.categoria === 'estudiantes'
                            ? 'Para Estudiantes'
                            : clase.categoria === 'devocional'
                            ? 'Devocional'
                            : clase.categoria === 'autocapacitacion'
                            ? 'Auto-Capacit. Estudiantes'
                            : clase.categoria === 'autocapacitacion_profesores'
                            ? 'Auto-Capacit. Profesores'
                            : 'Para Profesores'}
                        </Badge>
                        
                        {/* Badge de COPIA - Solo para admin */}
                        {user.rol === 'admin' && clase.es_copia && (
                          <Badge 
                            variant="outline"
                            className="text-xs bg-purple-50 text-purple-700 border-purple-300"
                          >
                            <i className="fas fa-copy mr-1"></i>
                            Copia
                          </Badge>
                        )}
                        
                        {/* Badge de estado activa/inactiva - Solo para admin */}
                        {user.rol === 'admin' && (
                          <Badge 
                            variant="outline"
                            className={`text-xs cursor-pointer ${
                              clase.activa 
                                ? 'bg-green-50 text-green-700 border-green-300 hover:bg-green-100' 
                                : 'bg-red-50 text-red-700 border-red-300 hover:bg-red-100'
                            }`}
                            onClick={() => handleToggleActiva(clase)}
                          >
                            <i className={`${clase.activa ? 'fas fa-check-circle' : 'fas fa-times-circle'} mr-1`}></i>
                            {clase.activa ? 'Activa' : 'Inactiva'}
                          </Badge>
                        )}
                      </div>
                      
                      {clase.semestres && clase.semestres.length > 0 ? (
                        clase.semestres.map(sem => (
                          <Badge key={sem} variant="outline" className="text-xs bg-blue-50 text-blue-700 border-blue-200">
                            <i className="fas fa-graduation-cap mr-1"></i>
                            {getSemestreNombre(sem)}
                          </Badge>
                        ))
                      ) : (
                        <Badge variant="outline" className="text-xs bg-blue-50 text-blue-700 border-blue-200">
                          <i className="fas fa-graduation-cap mr-1"></i>
                          Sin semestre
                        </Badge>
                      )}
                    </div>
                    
                    {/* Días de la semana */}
                    {clase.dias_semana && clase.dias_semana.length > 0 && (
                      <div className="flex flex-wrap gap-1 mb-2">
                        {clase.dias_semana.map((dia) => (
                          <Badge key={dia} variant="secondary" className="text-xs bg-blue-100 text-blue-800">
                            {dia.charAt(0).toUpperCase() + dia.slice(1)}
                          </Badge>
                        ))}
                      </div>
                    )}
                  </div>
                  {isStudentRole(user.rol) && (
                    <div className="ml-2">
                      {isInscrito(clase) ? (
                        <Badge variant="secondary" className="bg-green-100 text-green-800">
                          <i className="fas fa-check-circle mr-1"></i>
                          Inscrito
                        </Badge>
                      ) : (
                        <Badge variant="outline">
                          No inscrito
                        </Badge>
                      )}
                    </div>
                  )}
                </div>
              </CardHeader>
              <CardContent className="p-6">
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {clase.descripcion}
                </p>
                
                <div className="space-y-3 mb-4">
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="fas fa-calendar-alt mr-2 text-blue-600"></i>
                    <div>
                      <p className="font-medium">Inicio:</p>
                      <p>{formatDate(clase.fecha_inicio)}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="fas fa-clock mr-2 text-orange-600"></i>
                    <div>
                      <p className="font-medium">Fin:</p>
                      <p>{formatDate(clase.fecha_fin)}</p>
                    </div>
                  </div>
                  
                  {(user.rol === 'admin' || user.rol === 'profesor') ? (
                  <div 
                    className="flex items-center text-sm text-gray-500 cursor-pointer hover:text-blue-600 transition-colors group"
                    onClick={() => abrirModalEstudiantes(clase)}
                    title="Click para ver estudiantes inscritos"
                    data-testid="view-enrolled-students-btn"
                  >
                    <i className="fas fa-users mr-2 text-green-600 group-hover:text-blue-600 transition-colors"></i>
                    <span className="group-hover:underline">
                      {clase.estudiantes_inscritos?.length || 0} estudiantes inscritos
                    </span>
                  </div>
                  ) : (
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="fas fa-users mr-2 text-green-600"></i>
                    <span>{clase.estudiantes_inscritos?.length || 0} estudiantes inscritos</span>
                  </div>
                  )}
                  
                  {/* Código QR para asistencia presencial - Siempre visible */}
                  {clase.qr_code_data && (
                    <div 
                      className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-3 border-2 border-purple-200 cursor-pointer hover:shadow-lg transition-shadow"
                      onClick={() => abrirModalQR(clase)}
                      title="Haz clic para ver el QR en tamaño completo"
                    >
                      <div className="flex items-start space-x-3">
                        <div className="flex-shrink-0">
                          <div className="bg-white p-2 rounded border border-purple-300">
                            <QRCodeSVG 
                              value={`${window.location.origin}/marcar-asistencia-qr?clase_id=${clase.id}`}
                              size={80}
                              level="H"
                              includeMargin={false}
                            />
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-semibold text-purple-800 mb-1">
                            <i className="fas fa-qrcode mr-1"></i>
                            QR Asistencia Presencial
                          </p>
                          <p className="text-xs text-purple-600 mb-1">Para clases híbridas</p>
                          <p className="text-xs text-purple-500 italic">
                            <i className="fas fa-hand-pointer mr-1"></i>
                            Toca para expandir
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {clase.profesor_nombre && (
                    <div className="flex items-center text-sm text-gray-500">
                      <i className="fas fa-chalkboard-teacher mr-2 text-purple-600"></i>
                      <div>
                        <p className="font-medium">Profesor:</p>
                        <p>{clase.profesor_nombre}</p>
                        {clase.profesor_email && (
                          <p className="text-xs text-gray-400">{clase.profesor_email}</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                
                <div className="grid grid-cols-2 gap-2">
                  {clase.zoom_link && (
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full opacity-50 cursor-not-allowed text-blue-400"
                      disabled={true}
                      data-testid={`zoom-link-${clase.id}`}
                      title="Usa el botón Marcar Asistencia para ingresar a la clase en vivo"
                    >
                      <i className="fas fa-video mr-2"></i>
                      Unirse a Zoom
                    </Button>
                  )}
                  
                  {/* Botones de acceso para profesores y administradores */}
                  {(user.rol === 'admin' || user.rol === 'profesor') && (
                    <>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`formularios-${clase.id}`}
                      >
                        <i className="fas fa-clipboard-list mr-2 text-purple-600"></i>
                        Formularios
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`materiales-${clase.id}`}
                      >
                        <i className="fas fa-folder mr-2 text-green-600"></i>
                        Materiales
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`videos-${clase.id}`}
                      >
                        <i className="fab fa-youtube mr-2 text-red-600"></i>
                        Videos
                      </Button>
                    </>
                  )}
                  
                  {/* Botones de administración solo para profesores/admin */}
                  {(user.rol === 'admin' || (user.rol === 'profesor' && clase.profesor_id === user.id)) && (
                    <>
                      
                      {/* Botones de edición y administración */}
                      <div className="col-span-2 pt-2 border-t border-gray-200 grid grid-cols-2 gap-2">
                        {/* Botón Editar - disponible para profesores de la clase y administradores */}
                        <Button
                          variant="outline"
                          size="sm"
                          className="w-full btn-hover text-blue-600 hover:text-blue-700"
                          onClick={() => openEditDialog(clase)}
                          data-testid={`edit-clase-${clase.id}`}
                        >
                          <i className="fas fa-edit mr-2"></i>
                          Editar Clase
                        </Button>
                        
                        {/* Botón Inscribir Profesores - solo para capacitaciones y admin */}
                        {user.rol === 'admin' && clase.categoria === 'profesores' && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover bg-gradient-to-r from-purple-50 to-pink-50 text-purple-700 hover:text-purple-800 border-purple-300"
                            onClick={() => abrirModalInscribirProfesores(clase)}
                          >
                            <i className="fas fa-user-plus mr-2"></i>
                            Inscribir Profesores
                          </Button>
                        )}

                        {/* Botón Inscribir Estudiantes - solo para clases de estudiantes y admin */}
                        {user.rol === 'admin' && clase.categoria === 'estudiantes' && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 hover:text-green-800 border-green-300"
                            onClick={() => abrirModalInscribirEstudiantes(clase)}
                          >
                            <i className="fas fa-user-plus mr-2"></i>
                            Inscribir Estudiantes
                          </Button>
                        )}

                        {/* Botón Inscribir Usuarios - para devocionales y autocapacitacion (ambas variantes), admin puede inscribir cualquier rol */}
                        {user.rol === 'admin' && (clase.categoria === 'devocional' || clase.categoria === 'autocapacitacion' || clase.categoria === 'autocapacitacion_profesores') && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 hover:text-amber-800 border-amber-300"
                            onClick={() => abrirModalInscribirDevocional(clase)}
                            data-testid="inscribir-devocional-btn"
                          >
                            <i className="fas fa-user-plus mr-2"></i>
                            Inscribir Usuarios
                          </Button>
                        )}
                        
                        {/* Botón Ver Asistencias - DESHABILITADO: usar nueva página Asistencias */}
                        <Button
                          variant="outline"
                          size="sm"
                          className="w-full opacity-50 cursor-not-allowed text-purple-400"
                          disabled={true}
                          data-testid={`ver-asistencias-${clase.id}`}
                          title="Usa la nueva página de Asistencias en el menú lateral"
                        >
                          <i className="fas fa-users mr-2"></i>
                          Ver Asistencias
                        </Button>
                        
                        {/* Botón Exportar Asistencias - para profesores y administradores */}
                        <Button
                          variant="outline"
                          size="sm"
                          className="w-full btn-hover text-green-600 hover:text-green-700"
                          onClick={() => exportarAsistencias(clase.id)}
                          data-testid={`exportar-asistencias-${clase.id}`}
                        >
                          <i className="fas fa-file-excel mr-2"></i>
                          Exportar Asistencias
                        </Button>
                        
                        {/* Botón Desvincular Zoom - solo para administradores y profesores si hay Zoom vinculado */}
                        {(user.rol === 'admin' || user.rol === 'profesor') && clase.zoom_meeting_id && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover text-orange-600 hover:text-orange-700"
                            onClick={() => handleDesvincularZoom(clase)}
                            data-testid={`desvincular-zoom-${clase.id}`}
                          >
                            <i className="fas fa-unlink mr-2"></i>
                            Desvincular Zoom
                          </Button>
                        )}
                        
                        {/* Botón Duplicar - solo para administradores */}
                        {user.rol === 'admin' && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover text-blue-600 hover:text-blue-700"
                            onClick={() => handleDuplicarClase(clase)}
                            data-testid={`duplicar-clase-${clase.id}`}
                          >
                            <i className="fas fa-copy mr-2"></i>
                            Duplicar Clase
                          </Button>
                        )}
                        
                        {/* Botón Crear/Ver Reuniones de Zoom - solo para administradores */}
                        {user.rol === 'admin' && (
                          <div className="flex gap-2 w-full">
                            <Button
                              variant="outline"
                              size="sm"
                              className={`flex-1 btn-hover ${
                                clase.zoom_meeting_id || (clase.zoom_meetings && clase.zoom_meetings.length > 0)
                                  ? 'text-green-600 hover:text-green-700 cursor-not-allowed' 
                                  : 'text-purple-600 hover:text-purple-700'
                              }`}
                              onClick={() => !(clase.zoom_meeting_id || (clase.zoom_meetings && clase.zoom_meetings.length > 0)) && crearZoomMeeting(clase)}
                              disabled={creandoZoomMeeting[clase.id] || clase.zoom_meeting_id || (clase.zoom_meetings && clase.zoom_meetings.length > 0)}
                              data-testid={`crear-zoom-${clase.id}`}
                            >
                              {creandoZoomMeeting[clase.id] ? (
                                <>
                                  <i className="fas fa-spinner fa-spin mr-2"></i>
                                  Creando...
                                </>
                              ) : clase.zoom_meetings && clase.zoom_meetings.length > 0 ? (
                                <>
                                  <i className="fas fa-check-circle mr-2"></i>
                                  {clase.zoom_meetings.length} Zoom
                                </>
                              ) : clase.zoom_meeting_id ? (
                                <>
                                  <i className="fas fa-check-circle mr-2"></i>
                                  Zoom Asociado
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-video mr-2"></i>
                                  Crear Zoom
                                </>
                              )}
                            </Button>
                            {(clase.zoom_meeting_id || (clase.zoom_meetings && clase.zoom_meetings.length > 0)) && (
                              <>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="btn-hover text-orange-600 hover:text-orange-700"
                                  onClick={() => eliminarZoomMeetings(clase)}
                                  title="Eliminar reuniones de Zoom (borra en Zoom y en BD)"
                                >
                                  <i className="fas fa-trash"></i>
                                </Button>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="btn-hover text-gray-600 hover:text-gray-700"
                                  onClick={() => limpiarDatosZoom(clase)}
                                  title="Limpiar solo datos de BD (si ya borraste en Zoom)"
                                >
                                  <i className="fas fa-broom"></i>
                                </Button>
                              </>
                            )}
                          </div>
                        )}
                        
                        {/* Botón Eliminar - solo para administradores */}
                        {user.rol === 'admin' && (
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full btn-hover text-red-600 hover:text-red-700"
                            onClick={() => handleDeleteClase(clase)}
                            disabled={deleting}
                            data-testid={`delete-clase-${clase.id}`}
                          >
                            {deleting ? (
                              <>
                                <i className="fas fa-spinner fa-spin mr-2"></i>
                                Eliminando...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-trash mr-2"></i>
                                {clase.es_copia ? 'Eliminar Copia' : 'Eliminar Clase'}
                              </>
                            )}
                          </Button>
                        )}
                      </div>
                    </>
                  )}
                </div>
                  
                <div className="flex flex-col space-y-2">
                  {/* Botón de registro para profesores en clases "para profesores" (excepto el creador) */}
                  {user.rol === 'profesor' && (clase.categoria === 'profesores' || clase.categoria === 'devocional' || clase.categoria === 'autocapacitacion' || clase.categoria === 'autocapacitacion_profesores') && clase.profesor_id !== user.id && !isInscrito(clase) && (
                  <Button
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white btn-hover"
                      onClick={() => handleInscribirse(clase.id)}
                      data-testid={`profesor-inscribirse-${clase.id}`}
                    >
                      <i className="fas fa-chalkboard-teacher mr-2"></i>
                      Registrarse como Estudiante
                    </Button>
                  )}
                  
                  {/* Estado de inscripción para profesores */}
                  {user.rol === 'profesor' && (clase.categoria === 'profesores' || clase.categoria === 'devocional' || clase.categoria === 'autocapacitacion' || clase.categoria === 'autocapacitacion_profesores') && clase.profesor_id !== user.id && isInscrito(clase) && (
                    <div className="space-y-2">
                      <Badge className="w-full justify-center py-2 bg-purple-100 text-purple-800 hover:bg-purple-100">
                        <i className="fas fa-check-double mr-2"></i>
                        Registrado como Profesor
                      </Badge>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full text-red-600 hover:text-red-700 border-red-200 hover:border-red-300"
                        onClick={() => handleDesinscribirse(clase.id)}
                        data-testid={`profesor-desinscribirse-${clase.id}`}
                      >
                        <i className="fas fa-user-minus mr-2"></i>
                        Cancelar Registro
                      </Button>
                    </div>
                  )}
                  
                  {isStudentRole(user.rol) && (clase.categoria === 'estudiantes' || clase.categoria === 'devocional' || clase.categoria === 'autocapacitacion') && !isInscrito(clase) && (
                    <div className="space-y-2">
                      {puedeInscribirse(clase) ? (
                        <Button
                          className="w-full instituto-gradient text-white btn-hover"
                          onClick={() => handleInscribirse(clase.id, clase)}
                          data-testid={`inscribirse-${clase.id}`}
                        >
                          <i className="fas fa-user-plus mr-2"></i>
                          Inscribirse
                        </Button>
                      ) : (
                        <>
                          <Button
                            disabled
                            className="w-full bg-gray-300 text-gray-600 cursor-not-allowed"
                            data-testid={`inscribirse-disabled-${clase.id}`}
                          >
                            <i className="fas fa-lock mr-2"></i>
                            Matrícula Requerida
                          </Button>
                          <div className="bg-orange-50 border-l-4 border-orange-500 p-3 rounded">
                            <div className="flex items-start">
                              <i className="fas fa-info-circle text-orange-600 mt-1 mr-2"></i>
                              <div>
                                <p className="text-sm text-orange-900 font-medium">
                                  {getMensajeNoInscripcion(clase)}
                                </p>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="text-orange-700 hover:text-orange-800 p-0 h-auto mt-1"
                                  onClick={() => window.location.href = '/app/registraciones'}
                                >
                                  <i className="fas fa-arrow-right mr-1"></i>
                                  Renovar ahora
                                </Button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                  
                  {isStudentRole(user.rol) && (clase.categoria === 'estudiantes' || clase.categoria === 'devocional') && isInscrito(clase) && (
                    <div className="space-y-2">
                      <Badge className="w-full justify-center py-2 bg-green-100 text-green-800 hover:bg-green-100">
                        <i className="fas fa-check-double mr-2"></i>
                        Ya estás inscrito
                      </Badge>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`ver-formularios-${clase.id}`}
                      >
                        <i className="fas fa-clipboard-list mr-2 text-purple-600"></i>
                        Ver Formularios
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`ver-materiales-${clase.id}`}
                      >
                        <i className="fas fa-folder mr-2 text-green-600"></i>
                        Ver Materiales
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full opacity-50 cursor-not-allowed"
                        disabled={true}
                        data-testid={`ver-videos-${clase.id}`}
                      >
                        <i className="fab fa-youtube mr-2 text-red-600"></i>
                        Ver Videos
                      </Button>
                      
                      {/* Botón Marcar Asistencia - SIEMPRE visible para estudiantes */}
                      <Button
                        className="w-full instituto-gradient text-white btn-hover"
                        onClick={() => abrirModalAsistencia(clase)}
                        disabled={marcandoAsistencia[clase.id] || !esClaseDeHoy(clase)}
                        data-testid={`marcar-asistencia-${clase.id}`}
                        title={!esClaseDeHoy(clase) ? 'Solo puedes marcar asistencia el día de la clase' : 'Marcar tu asistencia'}
                      >
                        {marcandoAsistencia[clase.id] ? (
                          <>
                            <i className="fas fa-spinner fa-spin mr-2"></i>
                            Marcando...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-check-circle mr-2"></i>
                            {esClaseDeHoy(clase) ? 'Marcar Asistencia' : 'Asistencia (hoy no)'}
                          </>
                        )}
                      </Button>
                    </div>
                  )}
                  
                  {/* Mensaje para el profesor creador de la clase */}
                  {user.rol === 'profesor' && clase.categoria === 'profesores' && clase.profesor_id === user.id && (
                    <div className="w-full p-3 bg-blue-50 rounded-lg text-center border border-blue-200">
                      <p className="text-sm text-blue-700 font-medium">
                        <i className="fas fa-crown mr-2"></i>
                        Eres el creador de esta clase
                      </p>
                      <p className="text-xs text-blue-600 mt-1">
                        Otros profesores pueden registrarse para participar
                      </p>
                    </div>
                  )}
                  
                  {/* Mensaje para clases de profesores vistas por estudiantes */}
                  {isStudentRole(user.rol) && clase.categoria === 'profesores' && (
                    <div className="w-full p-3 bg-gray-100 rounded-lg text-center">
                      <p className="text-sm text-gray-600">
                        <i className="fas fa-lock mr-2"></i>
                        Clase para profesores únicamente
                      </p>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="shadow-lg border-0">
          <CardContent className="text-center py-12">
            <i className="fas fa-chalkboard text-gray-300 text-6xl mb-6"></i>
            {clases.length === 0 ? (
              <>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No hay clases disponibles</h3>
                <p className="text-gray-600 mb-6">
                  {isStudentRole(user.rol)
                    ? 'Aún no hay clases creadas. Consulta más tarde.'
                    : 'Comienza creando tu primera clase para los estudiantes.'}
                </p>
                {(user.rol === 'admin' || user.rol === 'profesor') && (
                  <Button
                    onClick={() => setIsDialogOpen(true)}
                    className="instituto-gradient text-white btn-hover"
                  >
                    <i className="fas fa-plus mr-2"></i>
                    Crear primera clase
                  </Button>
                )}
              </>
            ) : (
              <>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No se encontraron clases con estos filtros</h3>
                <p className="text-gray-600 mb-6">
                  Intenta ajustar los filtros para ver más resultados.
                </p>
                <Button
                  variant="outline"
                  onClick={() => {
                    setFiltroActiva('todas');
                    setFiltroSemestre('todos');
                    setFiltroAño('todos');
                  }}
                  className="instituto-gradient text-white btn-hover"
                >
                  <i className="fas fa-redo mr-2"></i>
                  Limpiar todos los filtros
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      )}

      {/* Edit Class Dialog */}
      <Dialog open={isEditDialogOpen} onOpenChange={setIsEditDialogOpen}>
        <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Editar Clase</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleEditClase} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="edit-titulo">Título de la clase *</Label>
              <Input
                id="edit-titulo"
                value={editForm.titulo || ''}
                onChange={(e) => setEditForm({ ...editForm, titulo: e.target.value })}
                placeholder="Ej: Introducción al Nuevo Testamento"
                required
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="edit-descripcion">Descripción *</Label>
              <Textarea
                id="edit-descripcion"
                value={editForm.descripcion || ''}
                onChange={(e) => setEditForm({ ...editForm, descripcion: e.target.value })}
                placeholder="Describe el contenido y objetivos de la clase"
                rows={3}
                required
              />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="edit-categoria">Categoría *</Label>
                <Select value={editForm.categoria} onValueChange={(value) => setEditForm({ ...editForm, categoria: value })}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="estudiantes">Para Estudiantes</SelectItem>
                    <SelectItem value="profesores">Para Profesores</SelectItem>
                    <SelectItem value="devocional">Devocional (todos los roles)</SelectItem>
                    <SelectItem value="autocapacitacion">Auto-Capacitación (Estudiantes) — se compra desde Registración</SelectItem>
                    <SelectItem value="autocapacitacion_profesores">Auto-Capacitación (Profesores) — admin la asigna</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              
              <div className="space-y-2">
                <Label>Semestres * (Selecciona uno o más)</Label>
                <div className="grid grid-cols-2 gap-3">
                  {semestresActivos.map(sem => (
                    <div key={sem} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        id={`edit-semestre-${sem}`}
                        checked={editForm.semestres?.includes(sem) || false}
                        onChange={(e) => {
                          const currentSemestres = editForm.semestres || [];
                          if (e.target.checked) {
                            setEditForm({ ...editForm, semestres: [...currentSemestres, sem] });
                          } else {
                            setEditForm({ ...editForm, semestres: currentSemestres.filter(s => s !== sem) });
                          }
                        }}
                        className="h-4 w-4 rounded border-gray-300"
                      />
                      <Label htmlFor={`edit-semestre-${sem}`} className="font-normal cursor-pointer">
                        {getSemestreNombre(sem)}
                      </Label>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-gray-500">
                  {user?.rol === 'admin' ? `Mostrando todos los semestres (${semestresActivos.length})` : `Mostrando semestres activos (${semestresActivos.length})`}
                </p>
              </div>
            </div>
            
            {/* Selector de profesor para edición - solo para administradores */}
            {user.rol === 'admin' && (
              <div className="space-y-2">
                <Label htmlFor="edit-profesor">Profesor Asignado</Label>
                <Select 
                  value={editForm.profesor_id || 'auto'} 
                  onValueChange={(value) => setEditForm({ ...editForm, profesor_id: value })}
                >
                  <SelectTrigger data-testid="edit-clase-profesor-select">
                    <SelectValue placeholder="Selecciona un profesor" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="auto">Sin cambiar asignación</SelectItem>
                    {profesores.map((profesor) => (
                      <SelectItem key={profesor.id} value={profesor.id}>
                        {profesor.nombre} {profesor.apellido} ({profesor.rol})
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <p className="text-xs text-gray-500">
                  Como administrador, puedes cambiar el profesor asignado a esta clase.
                </p>
              </div>
            )}
              
            {/* Checkboxes para tipo de clase especial - Edición (solo admin) */}
            {user.rol === 'admin' && (
              <div className="space-y-3 p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg border border-purple-200">
                <Label className="text-purple-800 font-semibold">Tipo de Clase Especial</Label>
                
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="edit_es_ministerial"
                    checked={editForm.es_ministerial || false}
                    onChange={(e) => setEditForm({ ...editForm, es_ministerial: e.target.checked })}
                    className="h-5 w-5 rounded border-purple-300 text-purple-600 mt-0.5"
                  />
                  <div>
                    <Label htmlFor="edit_es_ministerial" className="font-medium cursor-pointer text-purple-900">
                      ⛪ Clase Ministerial
                    </Label>
                    <p className="text-xs text-purple-700">
                      Clase de formación ministerial para servicio en la iglesia
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="edit_es_extracurricular"
                    checked={editForm.es_extracurricular || false}
                    onChange={(e) => setEditForm({ ...editForm, es_extracurricular: e.target.checked })}
                    className="h-5 w-5 rounded border-orange-300 text-orange-600 mt-0.5"
                  />
                  <div>
                    <Label htmlFor="edit_es_extracurricular" className="font-medium cursor-pointer text-orange-900">
                      📚 Clase Extracurricular
                    </Label>
                    <p className="text-xs text-orange-700">
                      Clase adicional fuera del currículum regular del semestre
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="edit_es_abierta"
                    checked={editForm.es_abierta || false}
                    onChange={(e) => setEditForm({ ...editForm, es_abierta: e.target.checked })}
                    className="h-5 w-5 rounded border-green-300 text-green-600 mt-0.5"
                  />
                  <div>
                    <Label htmlFor="edit_es_abierta" className="font-medium cursor-pointer text-green-900">
                      🔓 Clase Abierta
                    </Label>
                    <p className="text-xs text-green-700">
                      Pastores y Graduados pueden inscribirse sin necesidad de pagar semestre
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Modalidad de la clase (Vivo / Grabada) */}
            <div className="p-4 bg-gradient-to-br from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-lg space-y-2">
              <Label htmlFor="edit_modalidad" className="font-semibold text-indigo-900">
                📼 Modalidad de la Clase
              </Label>
              <select
                id="edit_modalidad"
                value={editForm.modalidad || 'vivo'}
                onChange={(e) => setEditForm({ ...editForm, modalidad: e.target.value })}
                className="w-full px-3 py-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                data-testid="edit-clase-modalidad"
              >
                <option value="vivo">🎥 Vivo (Zoom en vivo)</option>
                <option value="grabada">📼 Grabada (video pregrabado)</option>
              </select>
              <p className="text-xs text-indigo-700">
                {(editForm.modalidad || 'vivo') === 'grabada'
                  ? 'El estudiante irá a "Videos de Clases" el día de clase (asistencia se marca igual).'
                  : 'El estudiante entra a Zoom el día y hora de la clase.'}
              </p>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="edit-zoom">Link de Zoom (opcional)</Label>
              <Input
                id="edit-zoom"
                type="url"
                value={editForm.zoom_link || ''}
                onChange={(e) => setEditForm({ ...editForm, zoom_link: e.target.value })}
                placeholder="https://zoom.us/j/..."
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="edit-playlist">Playlist de YouTube (opcional)</Label>
              <Input
                id="edit-playlist"
                type="url"
                value={editForm.playlist_youtube || ''}
                onChange={(e) => setEditForm({ ...editForm, playlist_youtube: e.target.value })}
                placeholder="https://www.youtube.com/playlist?list=..."
              />
            </div>

            <div className="space-y-2">
              <Label>Días de la Semana *</Label>
              <div className="grid grid-cols-2 gap-2">
                {['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'].map((day) => (
                  <label key={day} className="flex items-center space-x-2 p-2 rounded border hover:bg-gray-50">
                    <input
                      type="checkbox"
                      checked={(editForm.dias_semana || []).includes(day)}
                      onChange={() => handleEditDayToggle(day)}
                      className="rounded text-blue-600"
                    />
                    <span className="capitalize text-sm">{day}</span>
                  </label>
                ))}
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="edit-fecha-inicio">Fecha y Hora de Inicio * (Hora de Uruguay UTC-3)</Label>
                <Input
                  id="edit-fecha-inicio"
                  type="datetime-local"
                  value={editForm.fecha_inicio || ''}
                  onChange={(e) => setEditForm({ ...editForm, fecha_inicio: e.target.value })}
                  required
                />
                <p className="text-xs text-blue-600">🇺🇾 Ingrese la hora en formato de 24 horas (Uruguay, UTC-3)</p>
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="edit-fecha-fin">Fecha y Hora de Fin * (Hora de Uruguay UTC-3)</Label>
                <Input
                  id="edit-fecha-fin"
                  type="datetime-local"
                  value={editForm.fecha_fin || ''}
                  onChange={(e) => setEditForm({ ...editForm, fecha_fin: e.target.value })}
                  required
                />
                <p className="text-xs text-blue-600">🇺🇾 Ingrese la hora en formato de 24 horas (Uruguay, UTC-3)</p>
              </div>
            </div>
            
            {/* Banner Upload - Solo para administradores */}
            {user.rol === 'admin' && (
              <div className="space-y-3">
                <Label className="text-base font-semibold">
                  <i className="fas fa-image mr-2 text-green-600"></i>
                  Banner de Clase
                </Label>
                
                {/* Preview del Banner */}
                {editForm.banner_url && (
                  <div className="mb-3">
                    <div className="flex items-center space-x-2 mb-2">
                      <Badge className="bg-green-600 text-white text-xs">
                        <i className="fas fa-check mr-1"></i>
                        Banner configurado
                      </Badge>
                      <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        onClick={() => {
                          setEditForm({ ...editForm, banner_url: '' });
                          toast.success('Banner eliminado del formulario');
                        }}
                        className="text-red-600 hover:text-red-700 h-7 text-xs"
                      >
                        <i className="fas fa-trash mr-1"></i>
                        Eliminar
                      </Button>
                    </div>
                    <img 
                      src={editForm.banner_url.startsWith('http') ? editForm.banner_url : getImageUrl(editForm.banner_url)} 
                      alt="Banner Preview" 
                      className="h-24 w-auto max-w-full object-cover rounded-lg border-2 border-green-200"
                      onError={(e) => {
                        console.error('Error loading banner preview:', editForm.banner_url);
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                
                {/* Opción 1: Subir desde PC */}
                <div>
                  <Label className="text-sm font-medium text-gray-700 mb-2 block">
                    <i className="fas fa-upload mr-2"></i>
                    Opción 1: Subir desde PC
                  </Label>
                  <input
                    id="edit-banner"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleBannerUpload(e, true)}
                    disabled={uploadingBanner}
                    className="file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100 w-full"
                  />
                  {uploadingBanner && (
                    <div className="text-sm text-gray-500 mt-2">
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Subiendo banner...
                    </div>
                  )}
                  <p className="text-xs text-gray-500 mt-2">
                    <i className="fas fa-info-circle mr-1"></i>
                    Formato: JPG, PNG. Tamaño recomendado: 1920x400px
                  </p>
                </div>
                
                {/* Divisor */}
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-gray-500">O</span>
                  </div>
                </div>
                
                {/* Opción 2: URL Externa */}
                <div>
                  <Label className="text-sm font-medium text-gray-700 mb-2 block">
                    <i className="fas fa-link mr-2"></i>
                    Opción 2: URL de Imagen Externa (Imgur, etc.)
                  </Label>
                  <Input
                    type="url"
                    placeholder="https://i.imgur.com/ejemplo.jpg"
                    value={editForm.banner_url || ''}
                    onChange={(e) => setEditForm({ ...editForm, banner_url: e.target.value })}
                    className="w-full"
                  />
                  <p className="text-xs text-gray-500 mt-2">
                    <i className="fas fa-info-circle mr-1"></i>
                    Pega aquí la URL completa de una imagen desde Imgur u otro servicio
                  </p>
                </div>
              </div>
            )}
            
            <div className="flex justify-end space-x-2 pt-4">
              <Button
                type="button"
                variant="outline"
                onClick={() => setIsEditDialogOpen(false)}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                disabled={updating}
                className="instituto-gradient text-white"
              >
                {updating ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Actualizando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save mr-2"></i>
                    Guardar Cambios
                  </>
                )}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* Modal de Asistencias */}
      <Dialog open={showAsistencias} onOpenChange={setShowAsistencias}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center">
              <i className="fas fa-users mr-2 text-purple-600"></i>
              Asistencias - {selectedClaseAsistencias?.titulo}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Header con botón de exportar */}
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-600">
                  Total de asistencias: <span className="font-semibold">{asistencias.length}</span>
                </p>
              </div>
              <Button
                onClick={() => exportarAsistencias(selectedClaseAsistencias?.id)}
                className="instituto-gradient text-white"
                size="sm"
              >
                <i className="fas fa-file-excel mr-2"></i>
                Exportar Excel
              </Button>
            </div>

            {/* Tabla de asistencias */}
            {asistencias.length > 0 ? (
              <div className="border rounded-lg overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Fecha
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Estudiante
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Email
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Estado
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {asistencias.map((asistencia, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {new Date(asistencia.fecha).toLocaleDateString('es-UY', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {asistencia.nombre_estudiante} {asistencia.apellido_estudiante}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {asistencia.email_estudiante}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <Badge 
                              className={`${
                                asistencia.presente 
                                  ? 'bg-green-100 text-green-800' 
                                  : 'bg-red-100 text-red-800'
                              }`}
                            >
                              <i className={`fas ${asistencia.presente ? 'fa-check' : 'fa-times'} mr-1`}></i>
                              {asistencia.presente ? 'Presente' : 'Ausente'}
                            </Badge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <i className="fas fa-users text-gray-400 text-4xl mb-4"></i>
                <p className="text-gray-500">No hay asistencias registradas para esta clase</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Selección de Asistencia */}
      <Dialog open={showAsistenciaModal} onOpenChange={setShowAsistenciaModal}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-center text-lg">
              <i className="fas fa-user-check mr-2 text-blue-600"></i>
              Marcar Asistencia
            </DialogTitle>
          </DialogHeader>
          
          {claseAsistenciaSeleccionada && (
            <div className="space-y-6">
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <h4 className="font-semibold text-gray-900 mb-2 text-center">
                  <i className="fas fa-chalkboard-teacher mr-2 text-blue-600"></i>
                  {claseAsistenciaSeleccionada.titulo}
                </h4>
                <p className="text-sm text-gray-700 text-center">
                  <i className="fas fa-calendar mr-2 text-blue-600"></i>
                  {formatDate(claseAsistenciaSeleccionada.fecha_inicio)}
                </p>
              </div>
              
              <div className="space-y-4">
                <p className="text-center text-gray-700 font-medium text-base">
                  Selecciona tu estado de asistencia:
                </p>
                
                <div className="space-y-3">
                  <Button
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-6 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                    onClick={() => abrirVerificacionCamara()}
                    disabled={marcandoAsistencia[claseAsistenciaSeleccionada.id]}
                    data-testid="asistencia-presente"
                  >
                    <div className="flex items-center justify-center space-x-3">
                      <i className="fas fa-check-circle text-2xl"></i>
                      <span className="text-lg font-medium">Presente</span>
                    </div>
                  </Button>
                  
                  <Button
                    className="w-full bg-red-600 hover:bg-red-700 text-white py-6 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                    onClick={() => marcarAsistencia(claseAsistenciaSeleccionada.id, false)}
                    disabled={marcandoAsistencia[claseAsistenciaSeleccionada.id]}
                    data-testid="asistencia-ausente"
                  >
                    <div className="flex items-center justify-center space-x-3">
                      <i className="fas fa-times-circle text-2xl"></i>
                      <span className="text-lg font-medium">Ausente</span>
                    </div>
                  </Button>
                </div>
                
                {marcandoAsistencia[claseAsistenciaSeleccionada.id] && (
                  <div className="text-center py-4 bg-gray-50 rounded-lg">
                    <i className="fas fa-spinner fa-spin mr-2 text-blue-600"></i>
                    <span className="text-gray-700 font-medium">Guardando asistencia...</span>
                  </div>
                )}
              </div>
              
              <div className="pt-4 border-t border-gray-200">
                <Button
                  variant="outline"
                  className="w-full py-3 text-gray-600 hover:text-gray-800 border-gray-300 hover:border-gray-400"
                  onClick={() => {
                    setShowAsistenciaModal(false);
                    setClaseAsistenciaSeleccionada(null);
                  }}
                  disabled={marcandoAsistencia[claseAsistenciaSeleccionada.id]}
                >
                  <i className="fas fa-times mr-2"></i>
                  Cancelar
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Verificación de Cámara */}
      <Dialog open={showCameraCheck} onOpenChange={(open) => {
        if (!open) {
          cancelarVerificacionCamara();
        }
      }}>
        <DialogContent className="sm:max-w-lg max-w-[95vw]">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-center text-lg">
              <i className="fas fa-video mr-2 text-blue-600"></i>
              Verificación de Cámara
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Vista previa de cámara */}
            <div className="relative bg-gray-900 rounded-lg overflow-hidden" style={{ aspectRatio: '4/3', maxHeight: '300px' }}>
              {cameraError ? (
                <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
                  <div className="text-center max-w-md">
                    {cameraError === 'no-camera' && (
                      <>
                        <i className="fas fa-video-slash text-5xl text-blue-500 mb-4"></i>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                          No se detectó cámara
                        </h3>
                        <p className="text-gray-700 mb-3">
                          No hay problema, puedes continuar sin verificación de cámara.
                          Asegúrate de tener tu cámara lista antes de entrar a Zoom.
                        </p>
                        <div className="bg-blue-100 border border-blue-300 rounded-lg p-3 mt-4">
                          <p className="text-sm text-blue-800">
                            💡 Podrás activar tu cámara directamente en Zoom
                          </p>
                        </div>
                      </>
                    )}
                    
                    {cameraError === 'permission-denied' && (
                      <>
                        <i className="fas fa-hand-paper text-5xl text-orange-500 mb-4"></i>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                          Permisos de cámara denegados
                        </h3>
                        <p className="text-gray-700 mb-3">
                          Has bloqueado el acceso a la cámara. No te preocupes, 
                          puedes continuar sin verificación.
                        </p>
                        <div className="bg-orange-100 border border-orange-300 rounded-lg p-3 mt-4">
                          <p className="text-sm text-orange-800">
                            💡 Podrás activar tu cámara directamente en Zoom
                          </p>
                        </div>
                      </>
                    )}
                    
                    {cameraError === 'no-supported' && (
                      <>
                        <i className="fas fa-exclamation-circle text-5xl text-gray-500 mb-4"></i>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                          Navegador sin soporte de cámara
                        </h3>
                        <p className="text-gray-700 mb-3">
                          Tu navegador no soporta acceso a cámara web. 
                          Puedes continuar sin verificación.
                        </p>
                        <div className="bg-gray-100 border border-gray-300 rounded-lg p-3 mt-4">
                          <p className="text-sm text-gray-700">
                            💡 Actualiza tu navegador para obtener la mejor experiencia
                          </p>
                        </div>
                      </>
                    )}
                    
                    {cameraError === 'unknown' && (
                      <>
                        <i className="fas fa-info-circle text-5xl text-indigo-500 mb-4"></i>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">
                          No se pudo acceder a la cámara
                        </h3>
                        <p className="text-gray-700 mb-3">
                          Ocurrió un problema al acceder a tu cámara. 
                          Puedes continuar sin verificación.
                        </p>
                        <div className="bg-indigo-100 border border-indigo-300 rounded-lg p-3 mt-4">
                          <p className="text-sm text-indigo-800">
                            💡 Tu cámara estará disponible en Zoom
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    className="w-full h-full object-cover"
                  />
                  {/* Overlay con indicador de grabación */}
                  <div className="absolute top-4 left-4 flex items-center space-x-2 bg-black bg-opacity-60 px-3 py-2 rounded-full">
                    <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                    <span className="text-white text-sm font-medium">En vivo</span>
                  </div>
                </>
              )}
            </div>

            {/* Instrucciones */}
            {!cameraError && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <div className="flex items-start space-x-2">
                  <i className="fas fa-info-circle text-blue-600 mt-1 text-sm"></i>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1 text-sm">
                      Verifica que tu cámara funcione correctamente
                    </h4>
                    <p className="text-xs text-blue-700">
                      Asegúrate de verte claramente antes de unirte a Zoom.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Botones de acción */}
            <div className="flex items-center justify-end space-x-2">
              <Button
                variant="outline"
                onClick={cancelarVerificacionCamara}
                className="px-4 text-sm"
                size="sm"
              >
                <i className="fas fa-times mr-1"></i>
                Cancelar
              </Button>
              
              {cameraError ? (
                <Button
                  className="bg-green-600 hover:bg-green-700 text-white px-4 text-sm"
                  onClick={confirmarYMarcarAsistencia}
                  size="sm"
                >
                  <i className="fas fa-arrow-right mr-1"></i>
                  Continuar
                </Button>
              ) : (
                <Button
                  className="bg-green-600 hover:bg-green-700 text-white px-4 text-sm"
                  onClick={confirmarYMarcarAsistencia}
                  disabled={!cameraStream}
                  size="sm"
                >
                  <i className="fas fa-check mr-1"></i>
                  OK, Ir a Zoom
                </Button>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Acceso a Zoom después de marcar presente */}
      <Dialog open={showZoomAccess} onOpenChange={setShowZoomAccess}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-center text-lg text-green-700">
              <i className="fas fa-video mr-2"></i>
              ¡Asistencia Confirmada!
            </DialogTitle>
          </DialogHeader>
          
          {claseZoomAcceso && (
            <div className="space-y-6">
              {/* Información de la clase */}
              <div className="bg-green-50 p-4 rounded-lg border border-green-200 text-center">
                <div className="flex items-center justify-center mb-2">
                  <i className="fas fa-check-circle text-2xl text-green-600 mr-2"></i>
                  <span className="text-green-800 font-semibold">Presente confirmado</span>
                </div>
                <h4 className="font-medium text-gray-900 mb-1">
                  {claseZoomAcceso.titulo}
                </h4>
                <p className="text-sm text-gray-600">
                  {formatDate(claseZoomAcceso.fecha_inicio)}
                </p>
              </div>

              {/* Recuadro de acceso a la clase */}
              <div className="bg-blue-50 p-6 rounded-lg border-2 border-blue-200">
                <div className="text-center space-y-4">
                  <div className="space-y-2">
                    <i className="fas fa-graduation-cap text-3xl text-blue-600"></i>
                    <h3 className="text-lg font-semibold text-blue-800">
                      Prepárate para ingresar a clase
                    </h3>
                    <p className="text-sm text-blue-700">
                      Tu asistencia ha sido registrada. ¡Es hora de unirte a la clase!
                    </p>
                  </div>
                  
                  <Button
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 text-lg font-semibold"
                    onClick={() => {
                      window.open(claseZoomAcceso.zoom_link, '_blank');
                      setShowZoomAccess(false);
                      setClaseZoomAcceso(null);
                    }}
                  >
                    <div className="flex items-center justify-center space-x-3">
                      <i className="fas fa-video text-xl"></i>
                      <span>Ingresar a Zoom</span>
                      <i className="fas fa-external-link-alt"></i>
                    </div>
                  </Button>
                </div>
              </div>

              {/* Botón para cerrar sin ingresar */}
              <div className="text-center">
                <Button
                  variant="outline"
                  className="px-6 py-2 text-gray-600 hover:text-gray-800"
                  onClick={() => {
                    setShowZoomAccess(false);
                    setClaseZoomAcceso(null);
                  }}
                >
                  <i className="fas fa-clock mr-2"></i>
                  Ingresar más tarde
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de QR para Asistencia Presencial */}
      <Dialog open={showQRModal} onOpenChange={setShowQRModal}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-center text-purple-700 flex items-center justify-center">
              <i className="fas fa-qrcode mr-2 text-2xl"></i>
              Código QR - Asistencia Presencial
            </DialogTitle>
          </DialogHeader>
          
          {selectedClaseQR && (
            <div className="space-y-4">
              {/* Información de la clase */}
              <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                <h4 className="font-semibold text-gray-900 mb-1 text-center">
                  {selectedClaseQR.titulo}
                </h4>
                <p className="text-sm text-gray-600 text-center">
                  {selectedClaseQR.categoria === 'estudiantes' ? 'Para Estudiantes' : 'Para Profesores'}
                </p>
              </div>

              {/* Instrucciones */}
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <p className="text-sm text-blue-800 text-center mb-2">
                  <i className="fas fa-info-circle mr-1"></i>
                  Toca el código QR para expandir en pantalla completa
                </p>
                <p className="text-xs text-blue-700 text-center">
                  💡 El brillo aumentará automáticamente para mejor escaneo
                </p>
              </div>

              {/* Código QR */}
              <div 
                className="flex flex-col items-center justify-center p-6 bg-white rounded-lg border-2 border-purple-300 cursor-pointer hover:shadow-lg transition-shadow"
                onClick={async () => {
                  // Aumentar brillo de pantalla al máximo
                  try {
                    if ('wakeLock' in navigator) {
                      const wakeLock = await navigator.wakeLock.request('screen');
                      console.log('Wake Lock activado - pantalla al máximo brillo');
                    }
                  } catch (err) {
                    console.log('Wake Lock no disponible:', err);
                  }
                  
                  // Abrir QR en pantalla completa en móviles
                  const qrUrl = `${window.location.origin}/marcar-asistencia-qr?clase_id=${selectedClaseQR.id}`;
                  const width = window.innerWidth;
                  
                  if (width < 768) {
                    // En móviles, abrir modal de pantalla completa
                    const qrFullScreen = document.getElementById('qr-fullscreen');
                    if (qrFullScreen) {
                      qrFullScreen.classList.remove('hidden');
                      // Agregar clase para fondo blanco brillante
                      qrFullScreen.style.backgroundColor = '#ffffff';
                    }
                  }
                }}
              >
                <QRCodeSVG 
                  value={`${window.location.origin}/marcar-asistencia-qr?clase_id=${selectedClaseQR.id}`}
                  size={200}
                  level="H"
                  includeMargin={true}
                />
                <p className="text-xs text-gray-500 mt-3 text-center">
                  Escanea con tu celular para marcar asistencia
                </p>
              </div>

              {/* Información adicional */}
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg border border-purple-200">
                <h5 className="font-semibold text-purple-800 mb-2 text-sm">
                  <i className="fas fa-lightbulb mr-1"></i>
                  ¿Cómo funciona?
                </h5>
                <ul className="text-xs text-purple-700 space-y-1">
                  <li>• Estudiantes escanean el QR con su celular</li>
                  <li>• Deben estar logueados en el sistema</li>
                  <li>• Se marca asistencia automáticamente</li>
                  <li>• Solo válido el día de la clase</li>
                  <li>• Marca única (no se puede repetir)</li>
                </ul>
              </div>

              <Button
                variant="outline"
                className="w-full"
                onClick={() => {
                  setShowQRModal(false);
                  setSelectedClaseQR(null);
                }}
              >
                <i className="fas fa-times mr-2"></i>
                Cerrar
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de QR en pantalla completa para móviles */}
      <div 
        id="qr-fullscreen" 
        className="hidden fixed inset-0 z-50 bg-white flex flex-col items-center justify-center p-4"
        onClick={(e) => {
          if (e.target.id === 'qr-fullscreen') {
            e.target.classList.add('hidden');
          }
        }}
      >
        {selectedClaseQR && (
          <>
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={() => document.getElementById('qr-fullscreen').classList.add('hidden')}
            >
              <i className="fas fa-times text-2xl"></i>
            </button>
            
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-purple-700 mb-2">
                {selectedClaseQR.titulo}
              </h3>
              <p className="text-gray-600">Asistencia Presencial</p>
            </div>
            
            <div className="bg-white p-8 rounded-lg shadow-2xl">
              <QRCodeSVG 
                value={`${window.location.origin}/marcar-asistencia-qr?clase_id=${selectedClaseQR.id}`}
                size={Math.min(window.innerWidth - 100, 400)}
                level="H"
                includeMargin={true}
              />
            </div>
            
            <p className="text-gray-600 mt-6 text-center">
              Escanea este código para marcar tu asistencia
            </p>
          </>
        )}
      </div>
      
      {/* Modal para Duplicar Clase */}
      <DuplicarClaseModal
        isOpen={isDuplicarModalOpen}
        onClose={() => setIsDuplicarModalOpen(false)}
        clase={selectedClaseForAction}
        semestres={semestresActivos.map(num => ({
          id: num,
          semester_number: num,
          numero: num,
          name: getSemestreNombre(num)
        }))}
        onDuplicar={ejecutarDuplicacion}
      />
      
      {/* Modal para Eliminar Clase */}
      <EliminarClaseModal
        isOpen={isEliminarModalOpen}
        onClose={() => setIsEliminarModalOpen(false)}
        clase={selectedClaseForAction}
        validacion={validacionEliminacion}
        onEliminar={ejecutarEliminacion}
        loading={deleting}
      />
      
      {/* Modal de Estudiantes Inscritos */}
      {showEstudiantesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden animate-in fade-in zoom-in duration-200">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-2xl font-bold flex items-center gap-2">
                    <i className="fas fa-users"></i>
                    Estudiantes Inscritos
                  </h3>
                  <p className="text-blue-100 mt-1 text-sm">
                    {selectedClaseEstudiantes?.titulo || selectedClaseEstudiantes?.nombre}
                  </p>
                </div>
                <button
                  onClick={cerrarModalEstudiantes}
                  className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-all"
                >
                  <i className="fas fa-times text-xl"></i>
                </button>
              </div>
            </div>
            
            {/* Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-120px)]">
              {loadingEstudiantes ? (
                <div className="flex flex-col items-center justify-center py-12">
                  <i className="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                  <p className="text-gray-600">Cargando estudiantes...</p>
                </div>
              ) : estudiantesInscritos.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-12">
                  <i className="fas fa-user-slash text-6xl text-gray-300 mb-4"></i>
                  <p className="text-gray-500 text-lg">No hay estudiantes inscritos en esta clase</p>
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-gray-200">
                    <p className="text-sm text-gray-600 font-medium">
                      Total: <span className="text-blue-600 font-bold text-lg">{estudiantesInscritos.length}</span> estudiante{estudiantesInscritos.length !== 1 ? 's' : ''}
                    </p>
                    {selectedClaseEstudiantes?.estudiantes_inscritos?.length > estudiantesInscritos.length && (
                      <div className="text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded flex items-center gap-1">
                        <i className="fas fa-exclamation-triangle"></i>
                        {selectedClaseEstudiantes.estudiantes_inscritos.length - estudiantesInscritos.length} inscripción(es) sin usuario activo
                      </div>
                    )}
                  </div>
                  
                  {estudiantesInscritos.map((estudiante, index) => (
                    <div
                      key={estudiante.id || index}
                      className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-4 border border-gray-200 hover:shadow-md transition-all hover:scale-[1.02] cursor-default"
                    >
                      <div className="flex items-start gap-4">
                        {/* Avatar */}
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                            {estudiante.nombre?.charAt(0)?.toUpperCase() || 'E'}
                          </div>
                        </div>
                        
                        {/* Info */}
                        <div className="flex-1 min-w-0">
                          <h4 className="font-semibold text-gray-900 text-lg flex items-center gap-2">
                            {estudiante.nombre} {estudiante.apellido}
                            {estudiante.rol === 'estudiante' && (
                              <Badge className="bg-green-100 text-green-700 text-xs">
                                <i className="fas fa-user-graduate mr-1"></i>
                                Estudiante
                              </Badge>
                            )}
                          </h4>
                          <div className="mt-2 space-y-1">
                            <p className="text-sm text-gray-600 flex items-center gap-2">
                              <i className="fas fa-envelope text-blue-600 w-4"></i>
                              <a href={`mailto:${estudiante.email}`} className="hover:text-blue-600 hover:underline">
                                {estudiante.email}
                              </a>
                            </p>
                            {estudiante.telefono && (
                              <p className="text-sm text-gray-600 flex items-center gap-2">
                                <i className="fas fa-phone text-green-600 w-4"></i>
                                {estudiante.telefono}
                              </p>
                            )}
                          </div>
                        </div>
                        
                        {/* Número de orden */}
                        <div className="flex-shrink-0 flex flex-col items-center gap-2">
                          <div className="bg-blue-100 text-blue-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                            {index + 1}
                          </div>
                          
                          {/* Botón eliminar - solo para admin */}
                          {user?.rol === 'admin' && (
                            <button
                              onClick={() => eliminarEstudianteDeClase(estudiante.id, `${estudiante.nombre} ${estudiante.apellido}`)}
                              className="text-red-600 hover:text-red-800 hover:bg-red-50 rounded-full p-2 transition-all"
                              title="Desinscribir estudiante"
                            >
                              <i className="fas fa-user-minus"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Footer */}
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <div className="flex justify-end">
                <Button
                  onClick={cerrarModalEstudiantes}
                  className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-6"
                >
                  <i className="fas fa-check mr-2"></i>
                  Cerrar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Inscribir Profesores */}
      <Dialog open={isInscribirProfesoresOpen} onOpenChange={setIsInscribirProfesoresOpen}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-purple-700">
              <i className="fas fa-user-plus mr-2"></i>
              Inscribir Profesores en Capacitación
            </DialogTitle>
            {claseParaInscribir && (
              <p className="text-sm text-gray-600 mt-2">
                <strong>Clase:</strong> {claseParaInscribir.nombre}
              </p>
            )}
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Mensaje opcional */}
            <div>
              <Label htmlFor="mensaje-opcional" className="text-sm font-medium text-gray-700">
                Mensaje Opcional (aparecerá en la notificación)
              </Label>
              <Textarea
                id="mensaje-opcional"
                value={mensajeOpcional}
                onChange={(e) => setMensajeOpcional(e.target.value)}
                placeholder="Ej: Esta capacitación es obligatoria para todos los profesores nuevos..."
                className="mt-1"
                rows={2}
              />
            </div>

            {/* Botón seleccionar todos */}
            {profesoresDisponibles.length > 0 && (
              <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg border border-purple-200">
                <input
                  type="checkbox"
                  checked={
                    profesoresSeleccionados.length > 0 &&
                    profesoresSeleccionados.length === profesoresDisponibles.filter(p => !p.yaInscrito).length
                  }
                  onChange={toggleSeleccionarTodos}
                  className="w-5 h-5 text-purple-600 rounded focus:ring-2 focus:ring-purple-500 cursor-pointer"
                  id="select-all-profesores"
                />
                <label htmlFor="select-all-profesores" className="font-semibold text-purple-900 cursor-pointer select-none">
                  Seleccionar todos ({profesoresDisponibles.filter(p => !p.yaInscrito).length} disponibles)
                </label>
              </div>
            )}

            {/* Lista de profesores */}
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {profesoresDisponibles.length === 0 ? (
                <p className="text-center text-gray-500 py-4">No hay profesores disponibles</p>
              ) : (
                profesoresDisponibles.map((profesor) => (
                  <div
                    key={profesor.id}
                    className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                      profesor.yaInscrito
                        ? 'bg-gray-100 border-gray-300 opacity-60'
                        : profesoresSeleccionados.includes(profesor.id)
                        ? 'bg-purple-50 border-purple-300 shadow-sm'
                        : 'bg-white border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={profesoresSeleccionados.includes(profesor.id)}
                      onChange={() => toggleProfesorSeleccion(profesor.id)}
                      disabled={profesor.yaInscrito}
                      className="w-5 h-5 text-purple-600 rounded focus:ring-2 focus:ring-purple-500 cursor-pointer disabled:cursor-not-allowed"
                      id={`prof-${profesor.id}`}
                    />
                    <div className="flex-1">
                      <label
                        htmlFor={`prof-${profesor.id}`}
                        className={`font-medium ${profesor.yaInscrito ? 'text-gray-500' : 'text-gray-800 cursor-pointer'}`}
                      >
                        {profesor.nombre} {profesor.apellido}
                      </label>
                      <p className="text-sm text-gray-600">{profesor.email}</p>
                      {profesor.yaInscrito && (
                        <Badge className="mt-1 bg-green-100 text-green-800 border-green-300">
                          <i className="fas fa-check mr-1"></i>
                          Ya inscrito
                        </Badge>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Contador de seleccionados */}
            {profesoresSeleccionados.length > 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-blue-800 font-medium">
                  <i className="fas fa-users mr-2"></i>
                  {profesoresSeleccionados.length} profesor(es) seleccionado(s)
                </p>
              </div>
            )}
          </div>

          {/* Botones de acción */}
          <div className="flex gap-3 justify-end pt-4 border-t">
            <Button
              variant="outline"
              onClick={() => setIsInscribirProfesoresOpen(false)}
              disabled={inscribiendo}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleInscribirProfesores}
              disabled={inscribiendo || profesoresSeleccionados.length === 0}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white"
            >
              {inscribiendo ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Inscribiendo...
                </>
              ) : (
                <>
                  <i className="fas fa-user-check mr-2"></i>
                  Inscribir {profesoresSeleccionados.length > 0 ? `(${profesoresSeleccionados.length})` : ''}
                </>
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal para Inscribir Estudiantes */}
      <Dialog open={isInscribirEstudiantesOpen} onOpenChange={setIsInscribirEstudiantesOpen}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-green-700">
              <i className="fas fa-user-plus mr-2"></i>
              Inscribir Estudiantes en Clase
            </DialogTitle>
            {claseParaInscribirEstudiantes && (
              <p className="text-sm text-gray-600 mt-2">
                <strong>Clase:</strong> {claseParaInscribirEstudiantes.titulo || claseParaInscribirEstudiantes.nombre}
              </p>
            )}
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Buscador */}
            <div>
              <Label htmlFor="buscar-estudiante" className="text-sm font-medium text-gray-700">
                Buscar Estudiante
              </Label>
              <Input
                id="buscar-estudiante"
                value={busquedaEstudiante}
                onChange={(e) => setBusquedaEstudiante(e.target.value)}
                placeholder="Buscar por nombre o email..."
                className="mt-1"
              />
            </div>

            {/* Botón seleccionar todos */}
            {estudiantesFiltrados.length > 0 && (
              <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200">
                <input
                  type="checkbox"
                  checked={
                    estudiantesSeleccionados.length > 0 &&
                    estudiantesSeleccionados.length === estudiantesFiltrados.filter(e => !e.yaInscrito).length
                  }
                  onChange={() => {
                    const noInscritos = estudiantesFiltrados.filter(e => !e.yaInscrito).map(e => e.id);
                    if (estudiantesSeleccionados.length === noInscritos.length) {
                      setEstudiantesSeleccionados([]);
                    } else {
                      setEstudiantesSeleccionados(noInscritos);
                    }
                  }}
                  className="w-5 h-5 text-green-600 rounded focus:ring-2 focus:ring-green-500 cursor-pointer"
                  id="select-all-estudiantes"
                />
                <label htmlFor="select-all-estudiantes" className="font-semibold text-green-900 cursor-pointer select-none">
                  Seleccionar todos ({estudiantesFiltrados.filter(e => !e.yaInscrito).length} disponibles)
                </label>
              </div>
            )}

            {/* Lista de estudiantes */}
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {estudiantesFiltrados.length === 0 ? (
                <p className="text-center text-gray-500 py-4">No se encontraron estudiantes</p>
              ) : (
                estudiantesFiltrados.map((estudiante) => (
                  <div
                    key={estudiante.id}
                    className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                      estudiante.yaInscrito
                        ? 'bg-gray-100 border-gray-300 opacity-60'
                        : estudiantesSeleccionados.includes(estudiante.id)
                        ? 'bg-green-50 border-green-300 shadow-sm'
                        : 'bg-white border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={estudiantesSeleccionados.includes(estudiante.id)}
                      onChange={() => {
                        if (estudiantesSeleccionados.includes(estudiante.id)) {
                          setEstudiantesSeleccionados(prev => prev.filter(id => id !== estudiante.id));
                        } else {
                          setEstudiantesSeleccionados(prev => [...prev, estudiante.id]);
                        }
                      }}
                      disabled={estudiante.yaInscrito}
                      className="w-5 h-5 text-green-600 rounded focus:ring-2 focus:ring-green-500 cursor-pointer disabled:cursor-not-allowed"
                      id={`est-${estudiante.id}`}
                    />
                    <div className="flex-1">
                      <label
                        htmlFor={`est-${estudiante.id}`}
                        className={`font-medium ${estudiante.yaInscrito ? 'text-gray-500' : 'text-gray-800 cursor-pointer'}`}
                      >
                        {estudiante.nombre} {estudiante.apellido}
                      </label>
                      <p className="text-sm text-gray-600">{estudiante.email}</p>
                      {estudiante.yaInscrito && (
                        <Badge className="mt-1 bg-green-100 text-green-800 border-green-300">
                          <i className="fas fa-check mr-1"></i>
                          Ya inscrito
                        </Badge>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Contador de seleccionados */}
            {estudiantesSeleccionados.length > 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-blue-800 font-medium">
                  <i className="fas fa-users mr-2"></i>
                  {estudiantesSeleccionados.length} estudiante(s) seleccionado(s)
                </p>
              </div>
            )}
          </div>

          {/* Botones de acción */}
          <div className="flex gap-3 justify-end pt-4 border-t">
            <Button
              variant="outline"
              onClick={() => setIsInscribirEstudiantesOpen(false)}
              disabled={inscribiendoEstudiantes}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleInscribirEstudiantes}
              disabled={inscribiendoEstudiantes || estudiantesSeleccionados.length === 0}
              className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white"
            >
              {inscribiendoEstudiantes ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Inscribiendo...
                </>
              ) : (
                <>
                  <i className="fas fa-user-check mr-2"></i>
                  Inscribir {estudiantesSeleccionados.length > 0 ? `(${estudiantesSeleccionados.length})` : ''}
                </>
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal para Inscribir Usuarios en Devocional */}
      <Dialog open={isInscribirDevocionalOpen} onOpenChange={setIsInscribirDevocionalOpen}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-amber-700">
              <i className="fas fa-user-plus mr-2"></i>
              Inscribir Usuarios en Devocional
            </DialogTitle>
            {claseParaInscribirDevocional && (
              <p className="text-sm text-gray-600 mt-2">
                <strong>Devocional:</strong> {claseParaInscribirDevocional.titulo || claseParaInscribirDevocional.nombre}
              </p>
            )}
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Filtro por rol */}
            <div className="flex flex-wrap gap-2">
              {['todos', 'estudiante', 'profesor', 'pastor', 'graduado', 'admin'].map(rol => (
                <button
                  key={rol}
                  onClick={() => setRolFiltroDevocional(rol)}
                  className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                    rolFiltroDevocional === rol
                      ? 'bg-amber-600 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                  data-testid={`filtro-rol-${rol}`}
                >
                  {rol === 'todos' ? 'Todos' : rol.charAt(0).toUpperCase() + rol.slice(1) + 's'}
                </button>
              ))}
            </div>

            {/* Buscador */}
            <Input
              value={busquedaDevocional}
              onChange={(e) => setBusquedaDevocional(e.target.value)}
              placeholder="Buscar por nombre o email..."
              data-testid="buscar-devocional-input"
            />

            {/* Seleccionar todos */}
            {usuariosFiltradosDevocional.length > 0 && (
              <div className="flex items-center gap-3 p-3 bg-amber-50 rounded-lg border border-amber-200">
                <input
                  type="checkbox"
                  checked={
                    usuariosSeleccionadosDevocional.length > 0 &&
                    usuariosSeleccionadosDevocional.length === usuariosFiltradosDevocional.filter(u => !u.yaInscrito).length
                  }
                  onChange={() => {
                    const noInscritos = usuariosFiltradosDevocional.filter(u => !u.yaInscrito).map(u => u.id);
                    if (usuariosSeleccionadosDevocional.length === noInscritos.length) {
                      setUsuariosSeleccionadosDevocional([]);
                    } else {
                      setUsuariosSeleccionadosDevocional(noInscritos);
                    }
                  }}
                  className="w-5 h-5 text-amber-600 rounded cursor-pointer"
                  id="select-all-devocional"
                />
                <label htmlFor="select-all-devocional" className="font-semibold text-amber-900 cursor-pointer select-none">
                  Seleccionar todos ({usuariosFiltradosDevocional.filter(u => !u.yaInscrito).length} disponibles)
                </label>
              </div>
            )}

            {/* Lista de usuarios */}
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {usuariosFiltradosDevocional.length === 0 ? (
                <p className="text-center text-gray-500 py-4">No se encontraron usuarios</p>
              ) : (
                usuariosFiltradosDevocional.map((u) => (
                  <div
                    key={u.id}
                    className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                      u.yaInscrito
                        ? 'bg-gray-100 border-gray-300 opacity-60'
                        : usuariosSeleccionadosDevocional.includes(u.id)
                        ? 'bg-amber-50 border-amber-300 shadow-sm'
                        : 'bg-white border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={usuariosSeleccionadosDevocional.includes(u.id)}
                      onChange={() => {
                        if (usuariosSeleccionadosDevocional.includes(u.id)) {
                          setUsuariosSeleccionadosDevocional(prev => prev.filter(id => id !== u.id));
                        } else {
                          setUsuariosSeleccionadosDevocional(prev => [...prev, u.id]);
                        }
                      }}
                      disabled={u.yaInscrito}
                      className="w-5 h-5 text-amber-600 rounded cursor-pointer disabled:cursor-not-allowed"
                      id={`dev-${u.id}`}
                    />
                    <div className="flex-1">
                      <label
                        htmlFor={`dev-${u.id}`}
                        className={`font-medium ${u.yaInscrito ? 'text-gray-500' : 'text-gray-800 cursor-pointer'}`}
                      >
                        {u.nombre} {u.apellido}
                      </label>
                      <div className="flex items-center gap-2">
                        <p className="text-sm text-gray-600">{u.email}</p>
                        <Badge className={`text-xs ${
                          u.rol === 'admin' ? 'bg-red-100 text-red-700' :
                          u.rol === 'profesor' ? 'bg-purple-100 text-purple-700' :
                          u.rol === 'pastor' ? 'bg-blue-100 text-blue-700' :
                          u.rol === 'graduado' ? 'bg-teal-100 text-teal-700' :
                          'bg-green-100 text-green-700'
                        }`}>
                          {u.rol}
                        </Badge>
                      </div>
                      {u.yaInscrito && (
                        <Badge className="mt-1 bg-green-100 text-green-800 border-green-300">
                          <i className="fas fa-check mr-1"></i>
                          Ya inscrito
                        </Badge>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Contador */}
            {usuariosSeleccionadosDevocional.length > 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-blue-800 font-medium">
                  <i className="fas fa-users mr-2"></i>
                  {usuariosSeleccionadosDevocional.length} usuario(s) seleccionado(s)
                </p>
              </div>
            )}
          </div>

          {/* Botones */}
          <div className="flex gap-3 justify-end pt-4 border-t">
            <Button
              variant="outline"
              onClick={() => setIsInscribirDevocionalOpen(false)}
              disabled={inscribiendoDevocional}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleInscribirDevocional}
              disabled={inscribiendoDevocional || usuariosSeleccionadosDevocional.length === 0}
              className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white"
              data-testid="confirmar-inscribir-devocional-btn"
            >
              {inscribiendoDevocional ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Inscribiendo...
                </>
              ) : (
                <>
                  <i className="fas fa-user-check mr-2"></i>
                  Inscribir {usuariosSeleccionadosDevocional.length > 0 ? `(${usuariosSeleccionadosDevocional.length})` : ''}
                </>
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      </>
      )}
    </div>
  );
};

export default Clases;
